var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewentriesAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-256",
    d: "M77.67,454.51c-95.18-54.95-95.18-144,0-199s249.49-55,344.66,0,95.18,144,0,199S172.84,509.46,77.67,454.51Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-256",
    d: "M363.69,282.19c-11.24,6.49-11.24,17,0,23.5s29.46,6.49,40.7,0,11.24-17,0-23.5S374.93,275.71,363.69,282.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-256",
    d: "M337,479.38,220.35,412.14c-1.81-1-1.81-2.74,0-3.78l125.18-72.14a7.22,7.22,0,0,1,6.56,0L468.7,403.46c1.81,1,1.81,2.74,0,3.78L343.51,479.38A7.2,7.2,0,0,1,337,479.38Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-256",
    d: "M168.42,407.74c-20,11.55-20,30.28,0,41.84s52.45,11.55,72.46,0,20-30.29,0-41.84S188.43,396.19,168.42,407.74Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-256"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "463.32 243.73 461.06 245.07 384.28 200.74 386.53 199.4 463.32 243.73",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.53 199.4 461.06 242.42 461.06 70.73 386.53 27.72 386.53 199.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,203.2l85.3,49.25V68.27L380,19Zm4.26-176.8,76.78,44.33V245.07l-76.78-44.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.28 200.74 386.53 199.4 386.53 27.72 384.28 26.4 384.28 200.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.06 182.68 461.06 185.33 384.28 141 386.53 139.66 461.06 182.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.06 122.92 461.06 125.56 384.28 81.23 386.53 79.89 461.06 122.92",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.02 19.02 382.31 17.71 467.61 66.96 465.32 68.27 380.02 19.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.61 66.96 465.32 68.27 465.32 252.45 467.61 251.14 467.61 66.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.22 51.77 425.93 50.44 425.93 224.8 428.22 223.49 428.22 51.77",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "421.67 48 425.93 50.44 425.93 224.8 421.67 222.33 421.67 48",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.02 78.78 380.02 83.69 465.32 132.94 465.32 128.03 380.02 78.78",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.02 138.53 380.02 143.44 465.32 192.69 465.32 187.78 380.02 138.53",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.93 105.28 428.22 103.95 461.06 122.92 461.06 125.56 425.93 105.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.93 165.02 428.22 163.7 461.06 182.66 461.06 185.31 425.93 165.02",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pictures--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-256"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.59 92.02 109.61 93.22 150.98 69.34 148.97 68.14 107.59 92.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.97 68.14 109.61 90.85 109.61 49.64 148.97 26.94 148.97 68.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.79,19.17l-49,28.28V99.81l49-28.27ZM151,69.34,109.61,93.23V49.64L151,25.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.98 69.34 148.97 68.14 148.97 26.94 150.98 25.76 150.98 69.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.79 19.17 152.74 18 103.76 46.27 105.81 47.45 154.79 19.17",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.76 46.27 105.81 47.45 105.81 99.81 103.76 98.64 103.76 46.27",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-256"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.43 66.91 111.15 87.85 111.15 77.38 120.22 56.43 125.87 61.67 123.84 70.45 136.37 43.66 147.43 56.43 147.43 66.91",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53,46.32A5.91,5.91,0,0,0,122.85,51c0,1.71,1.2,2.4,2.68,1.55a6,6,0,0,0,2.68-4.65C128.21,46.16,127,45.46,125.53,46.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-256"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "40.14 130.96 42.16 132.17 83.53 108.28 81.51 107.08 40.14 130.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.51 107.08 42.16 129.79 42.16 88.58 81.51 65.88 81.51 107.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.33,58.11l-49,28.28v52.36l49-28.27Zm-3.8,50.17L42.16,132.17V88.58L83.53,64.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.53 108.28 81.51 107.08 81.51 65.88 83.53 64.7 83.53 108.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.33 58.11 85.28 56.94 36.31 85.22 38.35 86.39 87.33 58.11",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.31 85.22 38.35 86.39 38.35 138.75 36.31 137.58 36.31 85.22",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-256"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "79.98 105.85 43.69 126.79 43.69 116.32 52.77 95.37 58.42 100.61 56.38 109.39 68.91 82.6 79.98 95.37 79.98 105.85",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.07,85.26a5.91,5.91,0,0,0-2.68,4.65c0,1.71,1.2,2.4,2.68,1.55a5.93,5.93,0,0,0,2.69-4.65C60.76,85.1,59.56,84.4,58.07,85.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.77,32.92l-6.56-3.82L36.61,173.21V390.7c0,2.23.78,3.8,2,4.53h0l6.56,3.82h0c1.26.73,3,.63,5-.49l235.6-136a15.46,15.46,0,0,0,7-12.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,398.71a5.55,5.55,0,0,0,2.72-.85l235.61-136A14.6,14.6,0,0,0,292,250.41V34.32L44,177.49v217C44,397.14,45.12,398.71,47,398.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.15,35.72V250.41A13.91,13.91,0,0,1,285,261.13l-235.6,136a4.77,4.77,0,0,1-2.32.74c-2,0-2.26-2.36-2.26-3.38V178L291.15,35.72m1.62-2.8L43.17,177V394.52c0,3.17,1.57,5,3.87,5a6.38,6.38,0,0,0,3.13-1l235.6-136a15.46,15.46,0,0,0,7-12.12V32.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.17 177.03 43.17 210.9 292.77 66.79 292.77 32.92 43.17 177.03",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.22,18.34c-1.27-.78-3-.69-5,.44L43.6,154.82a15.46,15.46,0,0,0-7,12.12v6.27L43.17,177,292.77,32.92V26.64c0-2.22-.78-3.77-2-4.51S285.36,19,284.22,18.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17,170.75a15.46,15.46,0,0,1,7-12.12l235.6-136c3.86-2.23,7-.42,7,4v6.28L43.17,177Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.81,22.17c-1.28-.79-3.05-.71-5,.43l-235.6,136a14.33,14.33,0,0,0-5,5.22l-6.57-3.8a14.22,14.22,0,0,1,5-5.23l235.6-136c2-1.13,3.75-1.21,5-.44s5.35,3.1,6.53,3.78A.15.15,0,0,0,290.81,22.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,37.51a5.41,5.41,0,0,0-2.44,4.24c0,1.55,1.09,2.19,2.44,1.41a5.42,5.42,0,0,0,2.45-4.24C270.78,37.37,269.68,36.73,268.33,37.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.88,32.59a5.39,5.39,0,0,0-2.44,4.23c0,1.56,1.09,2.19,2.44,1.41A5.4,5.4,0,0,0,279.33,34C279.33,32.44,278.23,31.81,276.88,32.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,27.66A5.41,5.41,0,0,0,283,31.9c0,1.55,1.09,2.19,2.44,1.41a5.42,5.42,0,0,0,2.45-4.24C287.88,27.52,286.78,26.88,285.43,27.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.17 177.03 36.61 173.21 36.61 207.11 43.17 210.9 43.17 177.03",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.17 177.03 36.61 173.21 36.61 207.11 43.17 210.9 43.17 177.03",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.17 177.03 36.61 173.21 36.61 207.11 43.17 210.9 43.17 177.03",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,180.22c0,5.95-3.62,12.86-8.08,15.44S51,195.5,51,189.55s3.62-12.87,8.09-15.45S67.19,174.26,67.19,180.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.11,192.08a1.63,1.63,0,0,1-1.64-1.64V179.32a1.64,1.64,0,1,1,3.27,0v11.12A1.63,1.63,0,0,1,59.11,192.08Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.94,188.93a1.64,1.64,0,0,1-.82-3.06l8.34-4.81a1.64,1.64,0,1,1,1.64,2.83l-8.35,4.82A1.59,1.59,0,0,1,54.94,188.93Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,178.92c-.19.12-.34.13-.44.06l-.22-.19L78,172.09v9.36a1.13,1.13,0,0,1-.13.51.93.93,0,0,1-.33.37l-1.37.79a.29.29,0,0,1-.33,0,.43.43,0,0,1-.13-.36V168.11a1.07,1.07,0,0,1,.13-.51.86.86,0,0,1,.33-.37l1.19-.69c.19-.11.34-.12.44,0a1.66,1.66,0,0,1,.22.19l4.77,6.69V164a1.13,1.13,0,0,1,.13-.51.93.93,0,0,1,.33-.37l1.38-.79a.27.27,0,0,1,.32,0,.42.42,0,0,1,.14.35v14.67a1.16,1.16,0,0,1-.14.51,1,1,0,0,1-.32.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.12,170.88a11.23,11.23,0,0,1,.29-2.56,11.41,11.41,0,0,1,.83-2.43,9.13,9.13,0,0,1,1.32-2.07,6.49,6.49,0,0,1,1.73-1.48,3.42,3.42,0,0,1,1.72-.53,2,2,0,0,1,1.32.49,2.94,2.94,0,0,1,.85,1.35,6.36,6.36,0,0,1,.29,2v1a1.07,1.07,0,0,1-.13.51.85.85,0,0,1-.32.37l-5.69,3.28a1.75,1.75,0,0,0,.16.83.89.89,0,0,0,.44.42,1,1,0,0,0,.63,0,2.37,2.37,0,0,0,.73-.28,4.29,4.29,0,0,0,.88-.66,3.51,3.51,0,0,0,.56-.7,5.1,5.1,0,0,1,.31-.43,1.42,1.42,0,0,1,.32-.25l1.37-.79a.3.3,0,0,1,.33,0,.4.4,0,0,1,.13.36,3.72,3.72,0,0,1-.27,1,7.1,7.1,0,0,1-.74,1.4A9.68,9.68,0,0,1,93,173.29a7.44,7.44,0,0,1-1.67,1.31,3.63,3.63,0,0,1-1.73.56,1.89,1.89,0,0,1-1.32-.5,3.21,3.21,0,0,1-.83-1.46A7.85,7.85,0,0,1,87.12,170.88Zm4.17-5.81a3.35,3.35,0,0,0-.85.68,4.34,4.34,0,0,0-.58.84,4.53,4.53,0,0,0-.37.89,4.8,4.8,0,0,0-.16.81l3.85-2.23a5.19,5.19,0,0,0-.13-.64,1,1,0,0,0-.31-.5.84.84,0,0,0-.56-.18A2.09,2.09,0,0,0,91.29,165.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72,161.27l1.54-7.37a2.89,2.89,0,0,1,.14-.45.7.7,0,0,1,.33-.37l1.3-.75a.29.29,0,0,1,.32,0,.43.43,0,0,1,.14.36,1,1,0,0,1,0,.17l-2.57,11.94a4.42,4.42,0,0,1-.15.48.85.85,0,0,1-.35.38l-1.29.74c-.16.09-.27.1-.33,0a1.15,1.15,0,0,1-.16-.29L103,161l-1.66,7a3,3,0,0,1-.16.48.74.74,0,0,1-.33.37l-1.29.75c-.16.09-.27.09-.34,0a.86.86,0,0,1-.16-.3l-2.57-9a.57.57,0,0,1,0-.14,1.14,1.14,0,0,1,.13-.52.83.83,0,0,1,.33-.36l1.29-.75c.16-.09.27-.09.33,0a1.51,1.51,0,0,1,.15.28l1.53,5.61,1.63-7.44a2,2,0,0,1,.16-.46.88.88,0,0,1,.32-.36l1.29-.75a.27.27,0,0,1,.32,0,.54.54,0,0,1,.16.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.27,155.2a11.89,11.89,0,0,1,.29-2.56,11.41,11.41,0,0,1,.83-2.43,10.43,10.43,0,0,1,1.32-2.07,6.42,6.42,0,0,1,1.73-1.47,3.38,3.38,0,0,1,1.73-.54,2.1,2.1,0,0,1,1.32.49,3,3,0,0,1,.84,1.35,6.35,6.35,0,0,1,.3,2v1a1.08,1.08,0,0,1-.14.5.85.85,0,0,1-.32.37l-5.69,3.29a1.73,1.73,0,0,0,.17.82.84.84,0,0,0,.43.42,1.09,1.09,0,0,0,.63.05,2.58,2.58,0,0,0,.73-.29,3.9,3.9,0,0,0,1.45-1.36,3.4,3.4,0,0,1,.3-.42,1.12,1.12,0,0,1,.33-.26l1.36-.79a.3.3,0,0,1,.33,0,.38.38,0,0,1,.13.36,3.61,3.61,0,0,1-.26,1,8.18,8.18,0,0,1-.75,1.41,10.58,10.58,0,0,1-1.21,1.52,7.25,7.25,0,0,1-1.68,1.3,3.5,3.5,0,0,1-1.73.56,1.88,1.88,0,0,1-1.32-.5,3.16,3.16,0,0,1-.83-1.46A8.2,8.2,0,0,1,114.27,155.2Zm4.17-5.81a3.34,3.34,0,0,0-.84.68,4.39,4.39,0,0,0-.59.84,4,4,0,0,0-.36.89,4.91,4.91,0,0,0-.17.81l3.85-2.22a3.46,3.46,0,0,0-.13-.64,1,1,0,0,0-.3-.51.81.81,0,0,0-.57-.17A1.93,1.93,0,0,0,118.44,149.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.79,149.8a1.13,1.13,0,0,1-.13.51,1,1,0,0,1-.33.37l-1.29.74a.27.27,0,0,1-.33,0,.42.42,0,0,1-.13-.35v-5.77a2.88,2.88,0,0,0-.48-1.9c-.32-.37-.8-.36-1.46,0a3.55,3.55,0,0,0-1.42,1.64,5.77,5.77,0,0,0-.52,2.48v5.77a1.16,1.16,0,0,1-.14.51,1,1,0,0,1-.32.37l-1.3.74a.27.27,0,0,1-.32,0,.43.43,0,0,1-.14-.36V144a1.09,1.09,0,0,1,.14-.51.85.85,0,0,1,.32-.37l1.3-.75a.27.27,0,0,1,.32,0,.41.41,0,0,1,.14.35v.52a8.73,8.73,0,0,1,1-1.57,5,5,0,0,1,1.41-1.21,3.38,3.38,0,0,1,1.74-.57,1.52,1.52,0,0,1,1.12.51,2.92,2.92,0,0,1,.6,1.34,9.53,9.53,0,0,1,.18,1.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,143.17a1.27,1.27,0,0,0,.28,1c.19.17.54.11,1.05-.19l1-.6a.27.27,0,0,1,.32,0,.41.41,0,0,1,.13.35v1.5a1.07,1.07,0,0,1-.13.51.92.92,0,0,1-.32.37l-1.26.72q-1.6.93-2.46.39c-.58-.36-.86-1.25-.86-2.67v-4.88l-1.13.65a.29.29,0,0,1-.32,0,.43.43,0,0,1-.14-.36v-1.5a1.16,1.16,0,0,1,.14-.51.88.88,0,0,1,.32-.36l1.13-.65v-3.7a1.07,1.07,0,0,1,.13-.51.81.81,0,0,1,.33-.37l1.29-.75a.27.27,0,0,1,.32,0,.41.41,0,0,1,.14.35v3.7l2.2-1.27a.27.27,0,0,1,.32,0,.41.41,0,0,1,.13.35v1.5a1.13,1.13,0,0,1-.13.51,1,1,0,0,1-.32.37l-2.2,1.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.58,133.37a3.66,3.66,0,0,0-1.47,1.45,4.83,4.83,0,0,0-.45,2.23V143a1.16,1.16,0,0,1-.14.51,1,1,0,0,1-.32.37l-1.3.74a.26.26,0,0,1-.32,0,.42.42,0,0,1-.14-.35V133.65a1.09,1.09,0,0,1,.14-.51.92.92,0,0,1,.32-.37l1.3-.75a.27.27,0,0,1,.32,0,.41.41,0,0,1,.14.35v.52a8.31,8.31,0,0,1,.94-1.38,5.12,5.12,0,0,1,1.32-1.06l.77-.44a.27.27,0,0,1,.32,0,.43.43,0,0,1,.14.36v1.49a1.09,1.09,0,0,1-.14.51.85.85,0,0,1-.32.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.25,138.54l-3.37-8.45a.61.61,0,0,1,0-.15,1.16,1.16,0,0,1,.14-.51,1,1,0,0,1,.32-.37l1.28-.73a.34.34,0,0,1,.36,0,.48.48,0,0,1,.2.25l2.26,5.7,2.27-8.32a1.82,1.82,0,0,1,.2-.48,1,1,0,0,1,.36-.39l1.28-.73a.26.26,0,0,1,.32,0,.42.42,0,0,1,.14.35.88.88,0,0,1,0,.17l-4.78,17.56a2.4,2.4,0,0,1-.21.49,1,1,0,0,1-.36.38l-1.27.74a.3.3,0,0,1-.33,0,.43.43,0,0,1-.13-.36,1,1,0,0,1,0-.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,230a1.14,1.14,0,0,1-.58-.15,1.65,1.65,0,0,1-.7-1.48V217.16a3.6,3.6,0,0,1,1.54-2.9l43.15-24.91a1.32,1.32,0,0,1,1.35-.07,1.61,1.61,0,0,1,.69,1.47v11.17a3.57,3.57,0,0,1-1.54,2.89L52.56,229.73A1.5,1.5,0,0,1,51.8,230ZM96,190.12a.67.67,0,0,0-.26.09L52.56,215.13a2.62,2.62,0,0,0-1,2v11.16c0,.34.1.55.2.61s.27,0,.34-.07L95.21,204a2.61,2.61,0,0,0,1-2V190.75a.78.78,0,0,0-.19-.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,216.42a.11.11,0,0,1,.11,0,.14.14,0,0,1,0,.13v.57a.31.31,0,0,1,0,.18.33.33,0,0,1-.11.14l-1.09.62v4.43a.49.49,0,0,1,0,.19.3.3,0,0,1-.12.13l-.49.28a.08.08,0,0,1-.11,0A.14.14,0,0,1,56,223v-4.43l-1.09.63a.13.13,0,0,1-.12,0,.17.17,0,0,1,0-.13v-.57a.41.41,0,0,1,0-.18.26.26,0,0,1,.12-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.22,215.61a.11.11,0,0,1,.11,0,.16.16,0,0,1,.05.13v.63a.41.41,0,0,1-.05.18.36.36,0,0,1-.11.13l-.53.3a.08.08,0,0,1-.11,0,.15.15,0,0,1,0-.12v-.63a.49.49,0,0,1,0-.19.36.36,0,0,1,.11-.13Zm.13,5.45a.45.45,0,0,1-.05.18.36.36,0,0,1-.11.13l-.47.26a.09.09,0,0,1-.11,0,.17.17,0,0,1,0-.13v-3.77a.41.41,0,0,1,0-.18.36.36,0,0,1,.11-.13l.47-.27a.11.11,0,0,1,.11,0,.17.17,0,0,1,.05.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.25,218.66a.43.43,0,0,0,.1.34c.06.06.19,0,.37-.06l.37-.22a.13.13,0,0,1,.12,0s0,.07,0,.13v.53a.39.39,0,0,1,0,.18.38.38,0,0,1-.12.13l-.45.26c-.38.22-.67.27-.88.14s-.3-.44-.3-1V217.4l-.4.23a.09.09,0,0,1-.12,0,.14.14,0,0,1,0-.12V217a.41.41,0,0,1,0-.18.38.38,0,0,1,.12-.13l.4-.23v-1.32a.31.31,0,0,1,0-.18.36.36,0,0,1,.11-.13l.46-.27a.13.13,0,0,1,.12,0,.17.17,0,0,1,0,.13V216l.78-.46a.11.11,0,0,1,.11,0,.14.14,0,0,1,0,.13v.53a.31.31,0,0,1,0,.18.29.29,0,0,1-.11.13l-.78.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,218.58a.39.39,0,0,1,0,.18.38.38,0,0,1-.12.13l-.46.27a.09.09,0,0,1-.12,0s0-.06,0-.12v-5.31a.39.39,0,0,1,0-.18.38.38,0,0,1,.12-.13l.46-.27a.13.13,0,0,1,.12,0,.17.17,0,0,1,0,.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.31,216.31a4.13,4.13,0,0,1,.11-.92,3.63,3.63,0,0,1,.29-.86,3.72,3.72,0,0,1,.47-.74,2.32,2.32,0,0,1,.62-.52,1.13,1.13,0,0,1,.61-.19.7.7,0,0,1,.47.17,1,1,0,0,1,.3.48,2.29,2.29,0,0,1,.11.73v.36a.41.41,0,0,1-.05.18.33.33,0,0,1-.11.14l-2,1.16a.61.61,0,0,0,.06.3.36.36,0,0,0,.15.15.44.44,0,0,0,.23,0,.77.77,0,0,0,.26-.1,1.31,1.31,0,0,0,.31-.23,1.36,1.36,0,0,0,.2-.25,1.49,1.49,0,0,1,.11-.15.4.4,0,0,1,.12-.1l.48-.28a.13.13,0,0,1,.12,0s0,.07,0,.13a1.45,1.45,0,0,1-.1.34,2.41,2.41,0,0,1-.26.5,4.13,4.13,0,0,1-.43.55,3.41,3.41,0,0,1-.6.46,1.28,1.28,0,0,1-.62.2.67.67,0,0,1-.47-.18,1,1,0,0,1-.29-.52A2.81,2.81,0,0,1,64.31,216.31Zm1.49-2.07a.89.89,0,0,0-.3.24,1.61,1.61,0,0,0-.21.3,1.37,1.37,0,0,0-.13.31,2.15,2.15,0,0,0-.06.29l1.37-.79a2.23,2.23,0,0,0,0-.23.54.54,0,0,0-.11-.18.32.32,0,0,0-.2-.06A.64.64,0,0,0,65.8,214.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,250.49a1.14,1.14,0,0,1-.58-.15,1.65,1.65,0,0,1-.7-1.48V237.69a3.6,3.6,0,0,1,1.54-2.89l43.15-24.92a1.34,1.34,0,0,1,1.35-.06,1.61,1.61,0,0,1,.69,1.47v11.17a3.57,3.57,0,0,1-1.54,2.89L52.56,250.27A1.61,1.61,0,0,1,51.8,250.49ZM96,210.66a.66.66,0,0,0-.27.09L52.56,235.67a2.62,2.62,0,0,0-1,2v11.17c0,.34.1.55.2.61s.27,0,.34-.07l43.15-24.91a2.61,2.61,0,0,0,1-2V211.29a.78.78,0,0,0-.19-.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.73,241a.53.53,0,0,1,.06-.19.34.34,0,0,1,.12-.12l.49-.28a.11.11,0,0,1,.12,0s0,.06,0,.13a3.55,3.55,0,0,1-.12.74,3.26,3.26,0,0,1-.33.78,3.85,3.85,0,0,1-.55.76,3.24,3.24,0,0,1-.81.63,1.65,1.65,0,0,1-.74.26.76.76,0,0,1-.54-.14,1,1,0,0,1-.35-.51,3.08,3.08,0,0,1-.15-.81c0-.2,0-.42,0-.67s0-.48,0-.69a5.4,5.4,0,0,1,.15-1,4,4,0,0,1,.35-.91,4.17,4.17,0,0,1,.54-.78,3.49,3.49,0,0,1,.74-.59,1.94,1.94,0,0,1,.81-.29.79.79,0,0,1,.88.53,1.88,1.88,0,0,1,.12.59.39.39,0,0,1,0,.18.51.51,0,0,1-.12.13l-.49.28a.13.13,0,0,1-.12,0,.15.15,0,0,1-.07-.12.77.77,0,0,0-.08-.27.48.48,0,0,0-.18-.17.46.46,0,0,0-.29,0,1.31,1.31,0,0,0-.42.16,1.9,1.9,0,0,0-.41.34,1.8,1.8,0,0,0-.29.43,1.9,1.9,0,0,0-.18.49,2.34,2.34,0,0,0-.08.52c0,.21,0,.44,0,.69s0,.47,0,.67a1.32,1.32,0,0,0,.08.43.53.53,0,0,0,.18.28.36.36,0,0,0,.29.09.84.84,0,0,0,.41-.14,1.9,1.9,0,0,0,.42-.31,2.48,2.48,0,0,0,.29-.37,2.25,2.25,0,0,0,.19-.38A1.76,1.76,0,0,0,57.73,241Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.22,238.72a1.81,1.81,0,0,1,.11-.43,2.59,2.59,0,0,1,.25-.5,2.31,2.31,0,0,1,.39-.51,2.79,2.79,0,0,1,.54-.42,1.84,1.84,0,0,1,.56-.22.67.67,0,0,1,.43.08.63.63,0,0,1,.27.37,1.82,1.82,0,0,1,.1.67v2.38a.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-.46.27a.13.13,0,0,1-.12,0,.16.16,0,0,1-.05-.13v-.26a2.44,2.44,0,0,1-.36.61,2.4,2.4,0,0,1-.61.52,1.17,1.17,0,0,1-.47.17.51.51,0,0,1-.35-.06.56.56,0,0,1-.21-.28,1.19,1.19,0,0,1-.08-.46,1.93,1.93,0,0,1,.3-1,3.47,3.47,0,0,1,.79-.89l1-.8c0-.22,0-.34-.16-.37a.53.53,0,0,0-.41.1.63.63,0,0,0-.23.19,1.8,1.8,0,0,0-.17.25.56.56,0,0,1-.1.14.28.28,0,0,1-.1.09l-.56.32s-.08,0-.1,0S59.21,238.78,59.22,238.72Zm1,1.7a1.48,1.48,0,0,0,.36-.29,1.78,1.78,0,0,0,.27-.36,1.65,1.65,0,0,0,.17-.39,1.63,1.63,0,0,0,0-.36v-.08l-.82.67a1.37,1.37,0,0,0-.36.37.66.66,0,0,0-.11.36c0,.11.05.17.13.17A.59.59,0,0,0,60.23,240.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.71,237.77a.5.5,0,0,0,.1.35c.07.06.19,0,.38-.07l.37-.21a.09.09,0,0,1,.11,0,.17.17,0,0,1,0,.13v.53a.49.49,0,0,1,0,.19.36.36,0,0,1-.11.13l-.45.26c-.38.21-.67.26-.88.13s-.31-.44-.31-.95v-1.74l-.39.24a.13.13,0,0,1-.12,0,.17.17,0,0,1,0-.13v-.53a.41.41,0,0,1,0-.18.26.26,0,0,1,.12-.13l.39-.24v-1.31a.41.41,0,0,1,0-.18.34.34,0,0,1,.12-.14l.46-.26a.08.08,0,0,1,.11,0s.05.06.05.12v1.32l.79-.45a.08.08,0,0,1,.11,0,.14.14,0,0,1,0,.12v.54a.41.41,0,0,1,0,.18.36.36,0,0,1-.11.13l-.79.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.16,236.36a4.13,4.13,0,0,1,.4-1.78,3.32,3.32,0,0,1,.47-.74,2.28,2.28,0,0,1,.61-.52,1.16,1.16,0,0,1,.62-.19.71.71,0,0,1,.47.17,1,1,0,0,1,.3.48,2.34,2.34,0,0,1,.1.73v.36a.42.42,0,0,1-.16.32l-2,1.17a.6.6,0,0,0,.06.29.33.33,0,0,0,.16.15.4.4,0,0,0,.22,0,.73.73,0,0,0,.26-.11,1.39,1.39,0,0,0,.32-.23,2.19,2.19,0,0,0,.2-.25.73.73,0,0,1,.11-.15.25.25,0,0,1,.11-.09l.49-.28a.09.09,0,0,1,.11,0,.14.14,0,0,1,0,.13,1.48,1.48,0,0,1-.09.35,2.79,2.79,0,0,1-.27.5,4.06,4.06,0,0,1-.43.54,2.51,2.51,0,0,1-.6.46,1.25,1.25,0,0,1-.61.2.66.66,0,0,1-.47-.18,1.14,1.14,0,0,1-.3-.52A2.78,2.78,0,0,1,65.16,236.36Zm1.48-2.07a1.22,1.22,0,0,0-.3.24,1.61,1.61,0,0,0-.21.3,1.81,1.81,0,0,0-.19.6l1.37-.79a1,1,0,0,0,0-.23.34.34,0,0,0-.11-.17.27.27,0,0,0-.2-.07A.8.8,0,0,0,66.64,234.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,236.37a1.07,1.07,0,0,0,.26-.2,1.5,1.5,0,0,0,.24-.31,1.4,1.4,0,0,0,.18-.39,1.31,1.31,0,0,0,.07-.44v-.3a2,2,0,0,1-.13.23,2.78,2.78,0,0,1-.19.27,2.17,2.17,0,0,1-.26.27,2,2,0,0,1-.33.24,1,1,0,0,1-.55.16.62.62,0,0,1-.42-.18,1,1,0,0,1-.27-.45,2.09,2.09,0,0,1-.12-.65v-.56a3.51,3.51,0,0,1,.12-.78,3.35,3.35,0,0,1,.27-.77,2.84,2.84,0,0,1,.42-.66,1.75,1.75,0,0,1,.55-.47,1.18,1.18,0,0,1,.33-.15l.26,0a.48.48,0,0,1,.19.05.32.32,0,0,1,.13.08v-.18a.49.49,0,0,1,0-.19.3.3,0,0,1,.12-.13l.46-.26a.08.08,0,0,1,.11,0,.14.14,0,0,1,0,.12v3.79a3.46,3.46,0,0,1-.41,1.71,2.91,2.91,0,0,1-1.13,1.15,1.84,1.84,0,0,1-.57.23,1,1,0,0,1-.46,0,.67.67,0,0,1-.31-.24.7.7,0,0,1-.13-.39.31.31,0,0,1,0-.18.28.28,0,0,1,.12-.14l.41-.24a.12.12,0,0,1,.14,0l.11.08a.3.3,0,0,0,.21.1A.78.78,0,0,0,70.17,236.37Zm-.73-2.71a3.38,3.38,0,0,0,0,.45c0,.34.11.54.24.62a.54.54,0,0,0,.51-.06,1.43,1.43,0,0,0,.5-.53,1.87,1.87,0,0,0,.23-.8,3,3,0,0,0,0-.32,2.63,2.63,0,0,0,0-.3.66.66,0,0,0-.23-.53.49.49,0,0,0-.5.05,1.41,1.41,0,0,0-.51.52A2.23,2.23,0,0,0,69.44,233.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.93,229.11a1.43,1.43,0,0,1,.61-.21A.7.7,0,0,1,75,229a.87.87,0,0,1,.32.38,1.83,1.83,0,0,1,.14.62v.81a4.26,4.26,0,0,1-.14.78,3.76,3.76,0,0,1-.32.74,3.32,3.32,0,0,1-.46.65,2.59,2.59,0,0,1-.61.48,1.35,1.35,0,0,1-.6.21.74.74,0,0,1-.47-.1.91.91,0,0,1-.31-.38,2.18,2.18,0,0,1-.14-.62,1.28,1.28,0,0,0,0-.18V232a1.48,1.48,0,0,0,0-.2,3.05,3.05,0,0,1,.14-.77,4.09,4.09,0,0,1,.31-.75,4.3,4.3,0,0,1,.47-.65A2.75,2.75,0,0,1,73.93,229.11Zm.74,1.39a.79.79,0,0,0-.09-.36.35.35,0,0,0-.17-.17.45.45,0,0,0-.23,0,1.06,1.06,0,0,0-.25.11,1.88,1.88,0,0,0-.24.18,1.47,1.47,0,0,0-.23.26,2,2,0,0,0-.17.36,1.71,1.71,0,0,0-.09.47c0,.05,0,.1,0,.17v.41c0,.06,0,.11,0,.15a.79.79,0,0,0,.09.36.35.35,0,0,0,.17.17.45.45,0,0,0,.23,0,.86.86,0,0,0,.24-.11,1.44,1.44,0,0,0,.25-.18,1.47,1.47,0,0,0,.23-.26,1.5,1.5,0,0,0,.17-.36,1.64,1.64,0,0,0,.09-.47v-.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.63,228a1.31,1.31,0,0,0-.53.51,1.83,1.83,0,0,0-.16.8v2.1a.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-.46.27a.13.13,0,0,1-.12,0,.17.17,0,0,1,0-.13v-3.76a.49.49,0,0,1,0-.19.3.3,0,0,1,.12-.13l.46-.26a.08.08,0,0,1,.11,0,.14.14,0,0,1,0,.12v.19a3.35,3.35,0,0,1,.34-.5,1.83,1.83,0,0,1,.47-.37l.27-.16a.09.09,0,0,1,.12,0s0,.06,0,.12v.54a.39.39,0,0,1,0,.18.51.51,0,0,1-.12.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.64,229.87l-1.2-3v-.05a.49.49,0,0,1,0-.19.36.36,0,0,1,.11-.13l.46-.26a.11.11,0,0,1,.12,0,.18.18,0,0,1,.08.09l.8,2,.81-3a.77.77,0,0,1,.07-.17.36.36,0,0,1,.13-.14l.45-.26s.09,0,.12,0a.14.14,0,0,1,0,.12.13.13,0,0,1,0,.06L80,231.24a1.08,1.08,0,0,1-.07.18.32.32,0,0,1-.13.13l-.46.27a.11.11,0,0,1-.11,0,.17.17,0,0,1,0-.13.13.13,0,0,1,0-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.14,122.54c.07,0,.12-.05.15,0a.34.34,0,0,1,.08.16l1.49,4.25v0a.39.39,0,0,1,0,.18c0,.07-.07.11-.12.13l-.44.26c-.08,0-.13,0-.17,0a.21.21,0,0,1-.06-.1l-.26-.75-1.92,1.11-.26,1a.47.47,0,0,1-.07.17.4.4,0,0,1-.17.17l-.43.25s-.09,0-.12,0a.15.15,0,0,1-.05-.12.35.35,0,0,1,0-.06l1.49-6a1.15,1.15,0,0,1,.08-.26.36.36,0,0,1,.15-.15Zm.34,3.35-.67-1.92-.67,2.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.54,122a1.12,1.12,0,0,1,.33-.14.63.63,0,0,1,.26,0,.59.59,0,0,1,.2,0l.12.09v-1.72a.49.49,0,0,1,.05-.19.3.3,0,0,1,.12-.13l.46-.26a.08.08,0,0,1,.11,0,.14.14,0,0,1,.05.12V125a.41.41,0,0,1-.05.18.33.33,0,0,1-.11.14l-.46.26q-.08,0-.12,0a.14.14,0,0,1-.05-.12v-.19a1.71,1.71,0,0,1-.12.23,2.34,2.34,0,0,1-.2.27,2.17,2.17,0,0,1-.26.27,2.85,2.85,0,0,1-.33.25,1,1,0,0,1-.55.15.71.71,0,0,1-.42-.17,1.1,1.1,0,0,1-.27-.45,1.88,1.88,0,0,1-.11-.65,2.44,2.44,0,0,1,0-.28,2.53,2.53,0,0,1,0-.29,3.12,3.12,0,0,1,.11-.78,3.8,3.8,0,0,1,.27-.76,3.38,3.38,0,0,1,.42-.66A1.92,1.92,0,0,1,259.54,122Zm-.57,2.28a3.53,3.53,0,0,0,0,.46c0,.33.11.54.25.61a.47.47,0,0,0,.5-.06,1.39,1.39,0,0,0,.5-.52,2,2,0,0,0,.23-.81,2.82,2.82,0,0,0,0-.31,2.45,2.45,0,0,0,0-.3.65.65,0,0,0-.23-.53.47.47,0,0,0-.5,0,1.26,1.26,0,0,0-.5.52A2,2,0,0,0,259,124.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,119.78a1.29,1.29,0,0,1,.34-.14.6.6,0,0,1,.26,0,.38.38,0,0,1,.19,0,.57.57,0,0,1,.13.08V118a.39.39,0,0,1,0-.18c0-.06.07-.11.12-.13l.46-.27a.08.08,0,0,1,.11,0s.05.06.05.12v5.31a.31.31,0,0,1-.05.18.36.36,0,0,1-.11.13l-.46.27a.13.13,0,0,1-.12,0,.17.17,0,0,1,0-.13v-.18c0,.06-.08.14-.13.23s-.12.17-.19.26a3.45,3.45,0,0,1-.26.28,1.72,1.72,0,0,1-.34.24,1,1,0,0,1-.55.16.67.67,0,0,1-.42-.18,1.23,1.23,0,0,1-.27-.45,2.15,2.15,0,0,1-.11-.65,2.35,2.35,0,0,1,0-.28,2.62,2.62,0,0,1,0-.29,3.66,3.66,0,0,1,.11-.78,4.89,4.89,0,0,1,.27-.76,3.7,3.7,0,0,1,.42-.66A2.07,2.07,0,0,1,263.29,119.78Zm-.56,2.29a1.69,1.69,0,0,0,0,.45c0,.34.1.54.24.61a.47.47,0,0,0,.5-.06,1.26,1.26,0,0,0,.5-.52,1.75,1.75,0,0,0,.24-.8c0-.09,0-.19,0-.32s0-.22,0-.3a.64.64,0,0,0-.24-.53.47.47,0,0,0-.5.05,1.39,1.39,0,0,0-.5.52A1.92,1.92,0,0,0,262.73,122.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,271a1.06,1.06,0,0,1-.58-.16,1.62,1.62,0,0,1-.7-1.47V258.23a3.6,3.6,0,0,1,1.54-2.89l43.15-24.92a1.32,1.32,0,0,1,1.35-.06,1.61,1.61,0,0,1,.69,1.47V243a3.57,3.57,0,0,1-1.54,2.89L52.56,270.81A1.61,1.61,0,0,1,51.8,271ZM96,231.2a.67.67,0,0,0-.26.09L52.56,256.21a2.6,2.6,0,0,0-1,2V269.4c0,.34.1.55.2.61s.27,0,.34-.07L95.21,245a2.57,2.57,0,0,0,1-2V231.83a.78.78,0,0,0-.19-.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,199.13a1.14,1.14,0,0,1-.58-.15,1.62,1.62,0,0,1-.7-1.48V186.34a3.6,3.6,0,0,1,1.54-2.9L278.83,83.34a1.32,1.32,0,0,1,1.34-.07,1.63,1.63,0,0,1,.69,1.48V95.91a3.59,3.59,0,0,1-1.53,2.9L105.94,198.91A1.5,1.5,0,0,1,105.18,199.13Zm174.4-115a.57.57,0,0,0-.25.08L105.94,184.31a2.64,2.64,0,0,0-1,2V197.5c0,.35.1.56.2.61s.27,0,.34-.07L278.83,97.94a2.63,2.63,0,0,0,1-2V84.75c0-.35-.09-.56-.19-.61A.13.13,0,0,0,279.58,84.12Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,219.67a1.14,1.14,0,0,1-.58-.15,1.62,1.62,0,0,1-.7-1.48V206.88a3.6,3.6,0,0,1,1.54-2.9l91.35-52.74a1.32,1.32,0,0,1,1.34-.07,1.65,1.65,0,0,1,.7,1.48v11.16a3.6,3.6,0,0,1-1.54,2.9l-91.35,52.74A1.5,1.5,0,0,1,105.18,219.67ZM197.55,152a.57.57,0,0,0-.26.09l-91.35,52.74a2.62,2.62,0,0,0-1,2V218c0,.34.1.55.2.61s.27,0,.34-.07l91.35-52.74a2.62,2.62,0,0,0,1-2V152.65c0-.34-.1-.55-.2-.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.4,161.8a1.19,1.19,0,0,1-.58-.15,1.63,1.63,0,0,1-.69-1.48V149a3.6,3.6,0,0,1,1.54-2.9l37.16-21.45a1.32,1.32,0,0,1,1.34-.07,1.63,1.63,0,0,1,.7,1.48v11.16a3.6,3.6,0,0,1-1.54,2.9l-37.16,21.45A1.53,1.53,0,0,1,205.4,161.8Zm38.19-36.36a.57.57,0,0,0-.26.09L206.17,147a2.61,2.61,0,0,0-1,2v11.16c0,.35.1.56.19.61s.28,0,.35-.06l37.16-21.46a2.64,2.64,0,0,0,1-2V126.07c0-.35-.1-.56-.2-.61A.11.11,0,0,0,243.59,125.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.44,135.22a1.13,1.13,0,0,1-.57-.15,1.61,1.61,0,0,1-.7-1.48V122.43a3.6,3.6,0,0,1,1.54-2.9l15.1-8.72a1.32,1.32,0,0,1,1.34-.06,1.62,1.62,0,0,1,.7,1.47v11.17a3.6,3.6,0,0,1-1.54,2.89L252.21,135A1.51,1.51,0,0,1,251.44,135.22Zm16.13-23.63a.57.57,0,0,0-.26.09l-15.1,8.72a2.64,2.64,0,0,0-1,2v11.16c0,.35.1.56.2.61s.27,0,.34-.07l15.1-8.71a2.64,2.64,0,0,0,1-2V112.22c0-.34-.1-.55-.2-.61Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,261.31a4,4,0,0,1,.14-1,3.58,3.58,0,0,1,.35-.89,3.53,3.53,0,0,1,.56-.77,3.69,3.69,0,0,1,.79-.61,2.08,2.08,0,0,1,.87-.32.87.87,0,0,1,.54.12.68.68,0,0,1,.29.36,1.73,1.73,0,0,1,.09.4.31.31,0,0,1,0,.19.51.51,0,0,1-.12.13l-.49.28a.12.12,0,0,1-.11,0l-.05-.06a1.15,1.15,0,0,1-.07-.11.43.43,0,0,0-.16-.13.68.68,0,0,0-.3,0,1.06,1.06,0,0,0-.45.17,1.88,1.88,0,0,0-.73.75,2.23,2.23,0,0,0-.29,1c0,.21,0,.43,0,.67s0,.45,0,.65c0,.44.11.71.29.81a.8.8,0,0,0,.73-.12,2.55,2.55,0,0,0,.41-.3,2.13,2.13,0,0,0,.33-.4,2,2,0,0,0,.21-.51,2.48,2.48,0,0,0,.07-.63V261l-.74.42a.09.09,0,0,1-.11,0,.17.17,0,0,1,0-.13v-.57a.41.41,0,0,1,0-.18.33.33,0,0,1,.11-.14l1.4-.8a.08.08,0,0,1,.11,0s0,.06,0,.12v.89a4.35,4.35,0,0,1-.11,1,3.91,3.91,0,0,1-.35.9,3.66,3.66,0,0,1-.57.8,3.9,3.9,0,0,1-.81.63,2.05,2.05,0,0,1-.8.3.81.81,0,0,1-.57-.13,1,1,0,0,1-.34-.5,2.76,2.76,0,0,1-.13-.82c0-.1,0-.21,0-.33v-.76C55,261.53,55,261.42,55,261.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,260.33a4.46,4.46,0,0,1,.4-1.77,3.46,3.46,0,0,1,.47-.74,2.37,2.37,0,0,1,.62-.53,1.22,1.22,0,0,1,.61-.19.76.76,0,0,1,.47.18,1,1,0,0,1,.3.48,2.29,2.29,0,0,1,.11.73v.36a.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-2,1.17a.64.64,0,0,0,.06.3.36.36,0,0,0,.15.15.44.44,0,0,0,.23,0,1.06,1.06,0,0,0,.26-.1,1.31,1.31,0,0,0,.31-.23,1.36,1.36,0,0,0,.2-.25l.11-.16.12-.09.48-.28a.13.13,0,0,1,.12,0s0,.07,0,.13a1.59,1.59,0,0,1-.1.34,2.68,2.68,0,0,1-.26.5,4.06,4.06,0,0,1-.43.54,3,3,0,0,1-.6.47,1.28,1.28,0,0,1-.62.2.67.67,0,0,1-.47-.18,1.13,1.13,0,0,1-.29-.52A2.83,2.83,0,0,1,59.2,260.33Zm1.49-2.07a1.05,1.05,0,0,0-.3.25,1.61,1.61,0,0,0-.21.3,1.37,1.37,0,0,0-.13.31,1.88,1.88,0,0,0-.06.29l1.37-.79a1.85,1.85,0,0,0,0-.23.4.4,0,0,0-.11-.18.32.32,0,0,0-.2-.06A.71.71,0,0,0,60.69,258.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8,258.41a.41.41,0,0,1,0,.18.26.26,0,0,1-.12.13l-.46.27s-.08,0-.11,0a.15.15,0,0,1,0-.12v-2.06a1.07,1.07,0,0,0-.17-.68c-.11-.12-.29-.12-.52,0a1.36,1.36,0,0,0-.51.59,2.1,2.1,0,0,0-.18.88v2.05a.41.41,0,0,1-.05.18.28.28,0,0,1-.12.14l-.46.26a.08.08,0,0,1-.11,0,.14.14,0,0,1,0-.12v-3.77a.41.41,0,0,1,0-.18A.29.29,0,0,1,63,256l.46-.27a.13.13,0,0,1,.12,0,.16.16,0,0,1,.05.13v.18a3,3,0,0,1,.37-.56,2.07,2.07,0,0,1,.5-.43,1.2,1.2,0,0,1,.62-.2.56.56,0,0,1,.4.18,1,1,0,0,1,.21.48,2.87,2.87,0,0,1,.07.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.08,254.08a1.33,1.33,0,0,0-.53.52,1.76,1.76,0,0,0-.16.79v2.1a.31.31,0,0,1,0,.18.29.29,0,0,1-.11.13l-.46.27a.13.13,0,0,1-.12,0s0-.07,0-.13v-3.76a.39.39,0,0,1,0-.18.34.34,0,0,1,.12-.14l.46-.26a.08.08,0,0,1,.11,0s0,.06,0,.12v.19a2.79,2.79,0,0,1,.34-.49,1.82,1.82,0,0,1,.47-.38l.27-.16s.09,0,.12,0a.15.15,0,0,1,0,.12v.54a.41.41,0,0,1,0,.18.26.26,0,0,1-.12.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.93,254.72a4,4,0,0,1,.11-.91,3.56,3.56,0,0,1,.29-.87,3.72,3.72,0,0,1,.47-.74,2.32,2.32,0,0,1,.62-.52,1.13,1.13,0,0,1,.61-.19.7.7,0,0,1,.47.17,1,1,0,0,1,.3.48,2.29,2.29,0,0,1,.11.73v.36a.41.41,0,0,1,0,.18.33.33,0,0,1-.11.14l-2,1.17a.6.6,0,0,0,.06.29.36.36,0,0,0,.15.15.36.36,0,0,0,.23,0,.77.77,0,0,0,.26-.1,1.31,1.31,0,0,0,.31-.23,1.46,1.46,0,0,0,.2-.25,1.49,1.49,0,0,1,.11-.15.27.27,0,0,1,.12-.09l.48-.28a.11.11,0,0,1,.12,0,.17.17,0,0,1,0,.13,1.64,1.64,0,0,1-.1.35,3,3,0,0,1-.26.5,3.48,3.48,0,0,1-.44.54,2.67,2.67,0,0,1-.59.46,1.28,1.28,0,0,1-.62.2.67.67,0,0,1-.47-.18,1,1,0,0,1-.29-.52A2.76,2.76,0,0,1,68.93,254.72Zm1.49-2.07a1,1,0,0,0-.3.24,1.25,1.25,0,0,0-.21.3,1.27,1.27,0,0,0-.13.32,1.77,1.77,0,0,0-.06.28l1.37-.79a1.06,1.06,0,0,0,0-.23.4.4,0,0,0-.1-.18.32.32,0,0,0-.2-.06A.64.64,0,0,0,70.42,252.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.52,164.45l-5.35,3.09c-.39.22-.7,0-.7-.54v-7.13a1.68,1.68,0,0,1,.7-1.35l5.35-3.09c.39-.23.71,0,.71.53v7.14A1.7,1.7,0,0,1,195.52,164.45Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,260.75a1.06,1.06,0,0,1-.58-.16,1.6,1.6,0,0,1-.7-1.47V248a3.6,3.6,0,0,1,1.54-2.89l174-100.48a1.32,1.32,0,0,1,1.34-.07,1.65,1.65,0,0,1,.7,1.48v11.17a3.6,3.6,0,0,1-1.54,2.89h0l-174,100.48A1.61,1.61,0,0,1,105.18,260.75ZM280.23,145.36a.57.57,0,0,0-.26.09l-174,100.47a2.64,2.64,0,0,0-1,2v11.17c0,.34.1.55.2.61s.27,0,.34-.07l174-100.48h0a2.62,2.62,0,0,0,1-2V146c0-.34-.1-.55-.2-.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.85,163.6a.55.55,0,0,1-.35-.12l-1.68-1.27a.58.58,0,1,1,.7-.92l1.13.86,1.37-2.61a.57.57,0,0,1,.77-.24.58.58,0,0,1,.25.78l-1.68,3.21a.55.55,0,0,1-.39.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,240.21a1.14,1.14,0,0,1-.58-.15,1.62,1.62,0,0,1-.7-1.48V227.41a3.6,3.6,0,0,1,1.54-2.89l67.72-39.1a1.32,1.32,0,0,1,1.34-.07,1.62,1.62,0,0,1,.7,1.48V198a3.6,3.6,0,0,1-1.54,2.9L105.94,240A1.61,1.61,0,0,1,105.18,240.21Zm68.74-54a.61.61,0,0,0-.26.09l-67.72,39.1a2.62,2.62,0,0,0-1,2v11.17c0,.34.1.55.2.61s.27,0,.34-.07L173.16,200a2.62,2.62,0,0,0,1-2V186.83c0-.34-.1-.55-.2-.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,291.57a1.15,1.15,0,0,1-.58-.16,1.62,1.62,0,0,1-.7-1.47V278.77a3.6,3.6,0,0,1,1.54-2.89L95.21,251a1.34,1.34,0,0,1,1.35-.07,1.64,1.64,0,0,1,.69,1.48v11.17a3.57,3.57,0,0,1-1.54,2.89L52.56,291.35A1.61,1.61,0,0,1,51.8,291.57ZM96,251.74a.66.66,0,0,0-.27.09L52.56,276.74a2.64,2.64,0,0,0-1,2v11.17c0,.34.1.55.2.61s.27,0,.34-.07l43.15-24.92a2.59,2.59,0,0,0,1-2V252.37a.78.78,0,0,0-.19-.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,278a.11.11,0,0,1,.11,0s0,.07,0,.13v.57a.31.31,0,0,1,0,.18.29.29,0,0,1-.11.13l-1.09.63v4.43a.41.41,0,0,1,0,.18.26.26,0,0,1-.12.13l-.49.29a.11.11,0,0,1-.11,0,.16.16,0,0,1-.05-.13v-4.43l-1.09.63a.11.11,0,0,1-.12,0,.17.17,0,0,1,0-.13v-.57a.49.49,0,0,1,0-.19.3.3,0,0,1,.12-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.51,281.42a.31.31,0,0,1,0,.18.33.33,0,0,1-.11.14l-.46.26a.09.09,0,0,1-.12,0s0-.06,0-.12v-2.06a1,1,0,0,0-.17-.67c-.12-.13-.29-.13-.53,0a1.25,1.25,0,0,0-.5.58,2,2,0,0,0-.19.88v2.06a.31.31,0,0,1-.05.18.36.36,0,0,1-.11.13l-.46.26a.11.11,0,0,1-.12,0,.17.17,0,0,1,0-.13v-5.3a.39.39,0,0,1,0-.18c0-.06.07-.11.12-.13l.46-.27a.08.08,0,0,1,.11,0s.05.06.05.12v1.73a3.72,3.72,0,0,1,.37-.57,1.74,1.74,0,0,1,.51-.42,1.2,1.2,0,0,1,.62-.21.55.55,0,0,1,.39.18,1,1,0,0,1,.22.48,3.69,3.69,0,0,1,.06.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.79,277.09a1.3,1.3,0,0,0-.52.52,1.66,1.66,0,0,0-.16.79v2.1a.41.41,0,0,1,0,.18.28.28,0,0,1-.12.14l-.46.26a.08.08,0,0,1-.11,0,.14.14,0,0,1,0-.12v-3.77a.41.41,0,0,1,0-.18.29.29,0,0,1,.11-.13l.46-.27a.13.13,0,0,1,.12,0,.16.16,0,0,1,0,.13v.18a2.62,2.62,0,0,1,.33-.49,1.82,1.82,0,0,1,.47-.38l.28-.15a.09.09,0,0,1,.11,0,.17.17,0,0,1,0,.13v.53a.41.41,0,0,1,0,.18.25.25,0,0,1-.11.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.65,277.73a4.13,4.13,0,0,1,.4-1.78,3.26,3.26,0,0,1,.47-.73,2.33,2.33,0,0,1,.61-.53,1.26,1.26,0,0,1,.62-.19.77.77,0,0,1,.47.17,1.14,1.14,0,0,1,.3.49,2.28,2.28,0,0,1,.1.72v.37a.39.39,0,0,1,0,.18.51.51,0,0,1-.12.13l-2,1.17a.76.76,0,0,0,0,.29.33.33,0,0,0,.16.15.4.4,0,0,0,.22,0,.93.93,0,0,0,.26-.1,1.77,1.77,0,0,0,.32-.24,1.16,1.16,0,0,0,.2-.25.73.73,0,0,1,.11-.15.53.53,0,0,1,.11-.09l.49-.28a.09.09,0,0,1,.12,0,.11.11,0,0,1,0,.12,1,1,0,0,1-.09.35,2.79,2.79,0,0,1-.27.5,3.39,3.39,0,0,1-.43.54,2.84,2.84,0,0,1-.6.47,1.22,1.22,0,0,1-.61.19.65.65,0,0,1-.47-.17,1.19,1.19,0,0,1-.3-.52A2.9,2.9,0,0,1,64.65,277.73Zm1.48-2.07a1.44,1.44,0,0,0-.3.24,2.73,2.73,0,0,0-.21.3,2.15,2.15,0,0,0-.13.32,1,1,0,0,0,0,.29l1.37-.79a1.55,1.55,0,0,0,0-.23.33.33,0,0,0-.11-.18.23.23,0,0,0-.2-.06A.76.76,0,0,0,66.13,275.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.29,274.56a1.64,1.64,0,0,1,.11-.42,2.93,2.93,0,0,1,.24-.51,2.72,2.72,0,0,1,.4-.51,2.52,2.52,0,0,1,.54-.42,1.5,1.5,0,0,1,.56-.21.62.62,0,0,1,.43.07.63.63,0,0,1,.27.37,1.82,1.82,0,0,1,.1.67V276a.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-.46.27s-.09,0-.12,0a.14.14,0,0,1,0-.12v-.27a2.78,2.78,0,0,1-.36.61,2.26,2.26,0,0,1-.62.52,1.28,1.28,0,0,1-.46.18.57.57,0,0,1-.35-.07.58.58,0,0,1-.21-.27,1.28,1.28,0,0,1-.08-.47,1.93,1.93,0,0,1,.3-1,3.64,3.64,0,0,1,.79-.89l1-.79c0-.22-.05-.35-.16-.38a.58.58,0,0,0-.41.1.75.75,0,0,0-.23.19,1.21,1.21,0,0,0-.17.25l-.1.15a.39.39,0,0,1-.1.08l-.56.32a.12.12,0,0,1-.11,0A.14.14,0,0,1,68.29,274.56Zm1,1.7a1.7,1.7,0,0,0,.36-.29,1.54,1.54,0,0,0,.27-.36,1.65,1.65,0,0,0,.17-.39,1.63,1.63,0,0,0,.05-.36v-.08l-.82.67a1.53,1.53,0,0,0-.36.37.69.69,0,0,0-.11.36c0,.11,0,.17.13.17A.51.51,0,0,0,69.3,276.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,270.75a1.81,1.81,0,0,1,.33-.15l.27,0,.19.05.12.09V269a.41.41,0,0,1,0-.18.3.3,0,0,1,.12-.13l.46-.26a.09.09,0,0,1,.11,0,.14.14,0,0,1,0,.13v5.3a.31.31,0,0,1,0,.18.25.25,0,0,1-.11.13l-.46.27q-.08,0-.12,0a.14.14,0,0,1,0-.12v-.19a1.71,1.71,0,0,1-.12.23l-.19.27-.27.27a1.65,1.65,0,0,1-.33.24,1,1,0,0,1-.55.16.67.67,0,0,1-.42-.18,1.1,1.1,0,0,1-.27-.44,1.88,1.88,0,0,1-.11-.65,2.44,2.44,0,0,1,0-.28,2.53,2.53,0,0,1,0-.29,3.12,3.12,0,0,1,.11-.78,4.55,4.55,0,0,1,.27-.76,3.46,3.46,0,0,1,.42-.67A2,2,0,0,1,73,270.75ZM72.39,273a3.38,3.38,0,0,0,0,.45c0,.34.11.54.25.62a.52.52,0,0,0,.5-.06,1.39,1.39,0,0,0,.5-.52,1.82,1.82,0,0,0,.23-.81,2.54,2.54,0,0,0,0-.31,2.11,2.11,0,0,0,0-.3c0-.27-.09-.45-.23-.53a.46.46,0,0,0-.5,0,1.35,1.35,0,0,0-.5.53A2,2,0,0,0,72.39,273Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.21,271.37c0-.06,0-.1,0-.12a.22.22,0,0,0-.15,0,1.6,1.6,0,0,0-.28.07l-.45.13a1.23,1.23,0,0,1-.44.05.43.43,0,0,1-.28-.12.58.58,0,0,1-.15-.28,1.8,1.8,0,0,1,0-.43,2.06,2.06,0,0,1,.08-.52,2.53,2.53,0,0,1,.25-.56,2.72,2.72,0,0,1,.39-.52,2.45,2.45,0,0,1,.53-.42,2.06,2.06,0,0,1,.53-.22.84.84,0,0,1,.39,0,.46.46,0,0,1,.26.19.67.67,0,0,1,.1.32.39.39,0,0,1,0,.18.43.43,0,0,1-.12.14l-.47.26a.18.18,0,0,1-.14,0l-.1,0a.2.2,0,0,0-.14,0,.65.65,0,0,0-.27.11,1.4,1.4,0,0,0-.33.26.51.51,0,0,0-.14.34.22.22,0,0,0,0,.13s.06,0,.13,0l.26-.05.43-.13c.36-.1.61-.09.76,0a.89.89,0,0,1,.22.69,1.72,1.72,0,0,1-.09.52,2.88,2.88,0,0,1-.26.57,3.45,3.45,0,0,1-.43.53,2.42,2.42,0,0,1-.56.44,2.05,2.05,0,0,1-.57.23.82.82,0,0,1-.42,0,.49.49,0,0,1-.26-.21.64.64,0,0,1-.09-.34.3.3,0,0,1,0-.18.38.38,0,0,1,.12-.13l.47-.27c.06,0,.1-.05.13,0l.11.06a.25.25,0,0,0,.16,0,.72.72,0,0,0,.31-.12,1,1,0,0,0,.18-.13.9.9,0,0,0,.18-.15,1.1,1.1,0,0,0,.14-.18A.31.31,0,0,0,77.21,271.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,198.63l-5.35,3.09c-.39.22-.71,0-.71-.54v-7.13a1.69,1.69,0,0,1,.71-1.35l5.35-3.09c.39-.23.7,0,.7.53v7.13A1.7,1.7,0,0,1,171.9,198.63Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.22,197.78a.59.59,0,0,1-.35-.12l-1.67-1.27a.58.58,0,0,1-.12-.81.58.58,0,0,1,.81-.11l1.14.86,1.36-2.6a.57.57,0,0,1,.78-.25.58.58,0,0,1,.24.78l-1.68,3.21a.56.56,0,0,1-.38.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.16,
    cy: 249.63,
    rx: 2.61,
    ry: 1.47,
    transform: "matrix(0.39, -0.92, 0.92, 0.39, -162.06, 254.18)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.66,245.3a4.07,4.07,0,0,1-1.7,3.25c-.93.54-1.7,0-1.7-1.29A4.08,4.08,0,0,1,117,244C117.9,243.48,118.66,244.05,118.66,245.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.46,242a4.05,4.05,0,0,1-1.7,3.24c-.94.54-1.7,0-1.7-1.28a4.07,4.07,0,0,1,1.7-3.25C123.7,240.13,124.46,240.71,124.46,242Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.44,359.8a1.17,1.17,0,0,1-.58-.15,1.61,1.61,0,0,1-.69-1.47v-55.9a3.59,3.59,0,0,1,1.53-2.89L278.83,168.84a1.3,1.3,0,0,1,1.34-.07,1.61,1.61,0,0,1,.69,1.47v55.9a3.59,3.59,0,0,1-1.53,2.89L53.2,359.58A1.47,1.47,0,0,1,52.44,359.8ZM279.58,169.62a.57.57,0,0,0-.25.08L53.2,300.25a2.63,2.63,0,0,0-1,2v55.9c0,.34.09.55.19.6s.28,0,.34-.06L278.83,228.16a2.59,2.59,0,0,0,1-2v-55.9c0-.34-.09-.55-.19-.6A.13.13,0,0,0,279.58,169.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.64,308.58l-5.35,3.09c-.39.23-.71,0-.71-.53V304a1.71,1.71,0,0,1,.71-1.36l5.35-3.08c.39-.23.71,0,.71.53v7.13A1.69,1.69,0,0,1,60.64,308.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,303.16l-5.35,3.09c-.39.22-.71,0-.71-.54v-7.13a1.69,1.69,0,0,1,.71-1.35L70,294.14c.39-.22.7,0,.7.54v7.13A1.69,1.69,0,0,1,70,303.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.43,297.74l-5.35,3.08c-.39.23-.71,0-.71-.53v-7.13a1.69,1.69,0,0,1,.71-1.35l5.35-3.09c.39-.23.71,0,.71.53v7.13A1.72,1.72,0,0,1,79.43,297.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.83,292.31l-5.35,3.09c-.39.23-.71,0-.71-.53v-7.14a1.7,1.7,0,0,1,.71-1.35l5.35-3.09c.39-.22.7,0,.7.54V291A1.68,1.68,0,0,1,88.83,292.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.22,286.89,92.87,290c-.39.22-.71,0-.71-.54v-7.13a1.69,1.69,0,0,1,.71-1.35l5.35-3.09c.39-.23.71,0,.71.53v7.14A1.7,1.7,0,0,1,98.22,286.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.62,281.46l-5.35,3.09c-.39.23-.71,0-.71-.53v-7.14a1.7,1.7,0,0,1,.71-1.35l5.35-3.09c.39-.22.7,0,.7.54v7.13A1.68,1.68,0,0,1,107.62,281.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,276l-5.35,3.09c-.39.22-.71,0-.71-.54v-7.13a1.69,1.69,0,0,1,.71-1.35L117,267c.39-.23.71,0,.71.53v7.14A1.7,1.7,0,0,1,117,276Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.41,270.61l-5.35,3.09c-.39.23-.71,0-.71-.53V266a1.7,1.7,0,0,1,.71-1.35l5.35-3.09c.39-.22.7,0,.7.54v7.13A1.68,1.68,0,0,1,126.41,270.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8,265.19l-5.35,3.09c-.39.22-.7,0-.7-.54v-7.13a1.68,1.68,0,0,1,.7-1.35l5.35-3.09c.39-.23.71,0,.71.53v7.14A1.7,1.7,0,0,1,135.8,265.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2,259.76l-5.35,3.09c-.39.23-.71,0-.71-.53v-7.13a1.72,1.72,0,0,1,.71-1.36l5.35-3.08c.39-.23.7,0,.7.53v7.13A1.68,1.68,0,0,1,145.2,259.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,254.34l-5.35,3.09c-.39.22-.7,0-.7-.54v-7.13a1.69,1.69,0,0,1,.7-1.35l5.35-3.09c.39-.22.71,0,.71.54V253A1.7,1.7,0,0,1,154.59,254.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,248.92,158.64,252c-.39.23-.71,0-.71-.53v-7.13a1.69,1.69,0,0,1,.71-1.35L164,239.9c.39-.23.71,0,.71.53v7.13A1.71,1.71,0,0,1,164,248.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.38,243.49,168,246.58c-.39.23-.7,0-.7-.53v-7.14a1.69,1.69,0,0,1,.7-1.35l5.35-3.09c.39-.22.71,0,.71.54v7.13A1.69,1.69,0,0,1,173.38,243.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78,238.07l-5.35,3.09c-.39.22-.71,0-.71-.54v-7.13a1.69,1.69,0,0,1,.71-1.35l5.35-3.09c.39-.23.71,0,.71.53v7.14A1.7,1.7,0,0,1,182.78,238.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.54,236.32a.82.82,0,0,1-.43-.12,1.11,1.11,0,0,1-.49-1v-7.14a2.19,2.19,0,0,1,.95-1.78L216.45,209a.92.92,0,0,1,1,0,1.09,1.09,0,0,1,.5,1v7.13a2.2,2.2,0,0,1-1,1.79l-29.88,17.24A1,1,0,0,1,186.54,236.32Zm30.36-26.39-29.83,17.22a1.21,1.21,0,0,0-.45.91v7.21l29.83-17.22a1.22,1.22,0,0,0,.46-.92V210S216.9,210,216.9,209.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,321.44a1,1,0,0,1-.5-1.86L271.91,195.77a1,1,0,0,1,1.37.36,1,1,0,0,1-.37,1.37L58.47,321.31A1,1,0,0,1,58,321.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,328.26a1,1,0,0,1-.5-1.87L271.91,202.58a1,1,0,1,1,1,1.74L58.47,328.13A1,1,0,0,1,58,328.26Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,335.08a1,1,0,0,1-.5-1.87L271.91,209.4a1,1,0,1,1,1,1.74L58.47,335A1,1,0,0,1,58,335.08Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,341.9a1,1,0,0,1-.5-1.87l74.33-42.91a1,1,0,0,1,1,1.73L58.47,341.77A1,1,0,0,1,58,341.9Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.73,362.77,53.45,386.6c-1,.57-1.78,0-1.78-1.35v-13.7a4.25,4.25,0,0,1,1.78-3.41l41.28-23.83c1-.57,1.78,0,1.78,1.35v13.7A4.29,4.29,0,0,1,94.73,362.77Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.24,372.38a.42.42,0,0,1,.17-.32l.49-.28a.11.11,0,0,1,.12,0s0,.07,0,.13a4.27,4.27,0,0,1-.13.74,3.67,3.67,0,0,1-.32.78,4,4,0,0,1-.55.76,3.65,3.65,0,0,1-.81.63,1.73,1.73,0,0,1-.74.26.75.75,0,0,1-.54-.14,1,1,0,0,1-.35-.51,2.34,2.34,0,0,1-.15-.81c0-.2,0-.42,0-.67s0-.48,0-.69a4.08,4.08,0,0,1,.15-1,3.72,3.72,0,0,1,.35-.91,3.44,3.44,0,0,1,.54-.77,2.87,2.87,0,0,1,.74-.6,1.85,1.85,0,0,1,.81-.29.82.82,0,0,1,.55.12.84.84,0,0,1,.32.41,2.21,2.21,0,0,1,.13.59.31.31,0,0,1,0,.18.26.26,0,0,1-.12.13l-.49.28a.12.12,0,0,1-.11,0,.15.15,0,0,1-.07-.12.77.77,0,0,0-.08-.27.52.52,0,0,0-.19-.17.63.63,0,0,0-.29,0,1.27,1.27,0,0,0-.41.16,1.73,1.73,0,0,0-.41.34,1.84,1.84,0,0,0-.3.43,2.6,2.6,0,0,0-.18.49,2.4,2.4,0,0,0-.07.52c0,.21,0,.44,0,.69s0,.47,0,.67a1.45,1.45,0,0,0,.07.44.71.71,0,0,0,.18.28.43.43,0,0,0,.3.08.9.9,0,0,0,.41-.14,1.84,1.84,0,0,0,.41-.31,2,2,0,0,0,.3-.37,1.64,1.64,0,0,0,.18-.38A1.89,1.89,0,0,0,65.24,372.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,366.5c.06,0,.11-.05.14,0a.34.34,0,0,1,.09.16l1.48,4.25a.07.07,0,0,1,0,.05.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-.44.26c-.08,0-.14.05-.17,0a.23.23,0,0,1-.07-.1l-.26-.75-1.91,1.11-.26,1.05-.07.17a.46.46,0,0,1-.17.17l-.44.25a.11.11,0,0,1-.11,0s0-.07,0-.13a.13.13,0,0,1,0-.06l1.48-6a.79.79,0,0,1,.09-.26.4.4,0,0,1,.14-.15Zm.33,3.35-.67-1.92-.66,2.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.75,369.25c-.07,0-.12.05-.15,0a.3.3,0,0,1-.08-.07l-1.7-2.38v3.33a.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-.5.29a.11.11,0,0,1-.11,0,.17.17,0,0,1,0-.13V365.4a.41.41,0,0,1,0-.18.29.29,0,0,1,.11-.13l.43-.25c.07,0,.12,0,.16,0l.08.06,1.69,2.39V364a.49.49,0,0,1,0-.19.3.3,0,0,1,.12-.13l.49-.28a.08.08,0,0,1,.11,0s0,.06,0,.12v5.22a.42.42,0,0,1-.16.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.89,365.07a.43.43,0,0,1,.07-.2.43.43,0,0,1,.11-.12l.49-.28a.13.13,0,0,1,.12,0,.14.14,0,0,1,0,.14,3.46,3.46,0,0,1-.12.73,4,4,0,0,1-.32.79,3.85,3.85,0,0,1-.56.75,3.69,3.69,0,0,1-.8.64,1.88,1.88,0,0,1-.74.26.83.83,0,0,1-.55-.15,1.1,1.1,0,0,1-.35-.51,2.62,2.62,0,0,1-.14-.81c0-.2,0-.42,0-.67s0-.47,0-.68a4.37,4.37,0,0,1,.49-1.9,3.49,3.49,0,0,1,.55-.77,2.83,2.83,0,0,1,.74-.59,1.77,1.77,0,0,1,.8-.3.9.9,0,0,1,.56.12.84.84,0,0,1,.32.41,1.94,1.94,0,0,1,.12.59.3.3,0,0,1,0,.18.38.38,0,0,1-.12.13l-.49.29a.17.17,0,0,1-.12,0s0-.05-.06-.12a.62.62,0,0,0-.09-.27.42.42,0,0,0-.18-.17.54.54,0,0,0-.29,0,.93.93,0,0,0-.41.16,1.49,1.49,0,0,0-.41.33,2.08,2.08,0,0,0-.3.43A2.05,2.05,0,0,0,76,364a3.28,3.28,0,0,0-.08.52c0,.21,0,.44,0,.69s0,.47,0,.67a1.82,1.82,0,0,0,.08.44.57.57,0,0,0,.18.28.49.49,0,0,0,.3.09,1,1,0,0,0,.41-.14,2.24,2.24,0,0,0,.41-.32,1.62,1.62,0,0,0,.29-.37,1.93,1.93,0,0,0,.19-.38A1.82,1.82,0,0,0,77.89,365.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,363.33a.09.09,0,0,1,.11,0,.12.12,0,0,1,0,.12V364a.31.31,0,0,1,0,.18.29.29,0,0,1-.11.13l-2.66,1.54a.13.13,0,0,1-.12,0,.16.16,0,0,1,0-.13v-5.22a.41.41,0,0,1,0-.18.38.38,0,0,1,.12-.13l2.61-1.51c.05,0,.08,0,.11,0s.05.07.05.13v.57a.31.31,0,0,1-.05.18.24.24,0,0,1-.11.13l-2,1.13v1.29l1.83-1.06a.11.11,0,0,1,.11,0,.17.17,0,0,1,0,.13v.57a.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-1.83,1.06v1.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,361.17a.13.13,0,0,1,.12,0,.17.17,0,0,1,0,.13v.57a.41.41,0,0,1,0,.18.34.34,0,0,1-.12.14l-2.65,1.53a.13.13,0,0,1-.12,0,.15.15,0,0,1,0-.12v-5.23a.41.41,0,0,1,0-.18.3.3,0,0,1,.12-.13l.49-.28a.09.09,0,0,1,.11,0,.14.14,0,0,1,0,.13v4.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.13,334.24l-41.28,23.84c-1,.57-1.78,0-1.78-1.35V343a4.27,4.27,0,0,1,1.78-3.4l41.28-23.83c1-.57,1.78,0,1.78,1.34v13.71A4.23,4.23,0,0,1,144.13,334.24Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.67,338.16a1.81,1.81,0,0,1,.71-.27.94.94,0,0,1,.52.07.6.6,0,0,1,.31.3,1,1,0,0,1,.12.43.39.39,0,0,1,0,.18.51.51,0,0,1-.12.13l-.43.24c-.07,0-.12.06-.15,0a.17.17,0,0,1-.1-.09.41.41,0,0,0-.27-.19.84.84,0,0,0-.55.17,1.29,1.29,0,0,0-.3.22,1.27,1.27,0,0,0-.25.27,1.52,1.52,0,0,0-.17.3.89.89,0,0,0-.06.31.49.49,0,0,0,.06.27.22.22,0,0,0,.2.09,1.06,1.06,0,0,0,.36-.05l.55-.15a3.09,3.09,0,0,1,.63-.12.89.89,0,0,1,.43.09.62.62,0,0,1,.25.32,1.4,1.4,0,0,1,.08.54,2.43,2.43,0,0,1-.12.74,2.78,2.78,0,0,1-.35.74A3.75,3.75,0,0,1,117.7,344a2.5,2.5,0,0,1-.65.27,1.27,1.27,0,0,1-.55,0,.67.67,0,0,1-.38-.28,1.08,1.08,0,0,1-.17-.55.41.41,0,0,1,0-.18.26.26,0,0,1,.12-.13l.42-.25a.22.22,0,0,1,.16,0,.13.13,0,0,1,.09.09.56.56,0,0,0,.1.15.32.32,0,0,0,.17.1.76.76,0,0,0,.25,0,1.54,1.54,0,0,0,.39-.17,2.71,2.71,0,0,0,.35-.24,2.76,2.76,0,0,0,.3-.29,1.94,1.94,0,0,0,.2-.33.76.76,0,0,0,.08-.36.3.3,0,0,0-.08-.24.39.39,0,0,0-.26-.05,4.11,4.11,0,0,0-.43.1l-.58.15a2.35,2.35,0,0,1-.54.08.62.62,0,0,1-.37-.11.71.71,0,0,1-.22-.33,1.86,1.86,0,0,1-.08-.59,2.45,2.45,0,0,1,.13-.74,3.34,3.34,0,0,1,.33-.72,3.71,3.71,0,0,1,.51-.63A2.68,2.68,0,0,1,117.67,338.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.08,335.69c.06,0,.11,0,.14,0a.45.45,0,0,1,.09.16l1.48,4.25a.07.07,0,0,1,0,.05.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-.44.26c-.08,0-.14.05-.17,0a.16.16,0,0,1-.07-.09l-.26-.75L120.79,341l-.27,1.05a.88.88,0,0,1-.06.17.38.38,0,0,1-.17.16l-.44.26a.11.11,0,0,1-.11,0,.14.14,0,0,1,0-.13v-.06l1.49-6a1.15,1.15,0,0,1,.08-.26.43.43,0,0,1,.15-.15Zm.33,3.36-.67-1.92-.66,2.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58,337.73l1-4.44a.7.7,0,0,1,.06-.17.29.29,0,0,1,.14-.15l.46-.27a.13.13,0,0,1,.12,0s0,.07,0,.13v0a.18.18,0,0,1,0,.06l-1.36,5.87a1.15,1.15,0,0,1-.08.26.36.36,0,0,1-.15.15l-.48.28c-.07,0-.11,0-.15,0a.3.3,0,0,1-.08-.15l-1.36-4.3a.11.11,0,0,1,0,0v0a.31.31,0,0,1,.05-.18.36.36,0,0,1,.11-.13l.46-.27c.06,0,.11,0,.14,0a.18.18,0,0,1,.06.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89,335.25a.13.13,0,0,1,.12,0,.17.17,0,0,1,0,.13V336a.39.39,0,0,1,0,.18c0,.06-.07.11-.12.13l-2.66,1.54a.09.09,0,0,1-.12,0s0-.06,0-.12v-5.22a.46.46,0,0,1,0-.19.51.51,0,0,1,.12-.13l2.61-1.51a.13.13,0,0,1,.12,0,.17.17,0,0,1,0,.13v.57a.41.41,0,0,1,0,.18.26.26,0,0,1-.12.13l-2,1.13v1.29l1.83-1.05a.09.09,0,0,1,.11,0,.14.14,0,0,1,.05.13v.57a.31.31,0,0,1-.05.18.33.33,0,0,1-.11.14l-1.83,1.05v1.34Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.6,296.39c-9-9.3-14.32-47.18-5.52-54.56h44.76c8.79,7.38,3.5,45.24-5.51,54.55l-.25.26-.31.31c-.26.25-.53.49-.82.73l-.21.17c-.22.18-.44.35-.68.52a12.75,12.75,0,0,1-1.17.75c-7.42,4.34-19.45,4.34-26.87,0h0a12.9,12.9,0,0,1-1.17-.76c-.23-.15-.43-.32-.64-.48l-.26-.21c-.28-.23-.54-.47-.79-.71l-.36-.35C367.74,296.54,367.66,296.47,367.6,296.39Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.6,296.39c-9-9.3-14.32-47.18-5.52-54.56h44.76c8.79,7.38,3.5,45.24-5.51,54.55l-.25.26-.31.31c-.26.25-.53.49-.82.73l-.21.17c-.22.18-.44.35-.68.52a12.75,12.75,0,0,1-1.17.75c-7.42,4.34-19.45,4.34-26.87,0h0a12.9,12.9,0,0,1-1.17-.76c-.23-.15-.43-.32-.64-.48l-.26-.21c-.28-.23-.54-.47-.79-.71l-.36-.35C367.74,296.54,367.66,296.47,367.6,296.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403,238.86c10.21,6,10.21,15.63,0,21.59s-26.77,6-37,0-10.21-15.63,0-21.59S392.74,232.89,403,238.86Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403,238.86c10.21,6,10.21,15.63,0,21.59s-26.77,6-37,0-10.21-15.63,0-21.59S392.74,232.89,403,238.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M398,241.72c7.5,4.38,7.5,11.48,0,15.86s-19.66,4.38-27.16,0-7.5-11.48,0-15.86S390.54,237.35,398,241.72Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,241.72c7.5,4.38,7.5,11.48,0,15.86s-19.66,4.38-27.16,0-7.5-11.48,0-15.86S390.54,237.35,398,241.72Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.88,249.25c7.5-4.38,19.66-4.38,27.16,0a12.6,12.6,0,0,1,4.49,4.17,12.58,12.58,0,0,1-4.49,4.16c-7.5,4.38-19.66,4.38-27.16,0a12.54,12.54,0,0,1-4.5-4.16A12.55,12.55,0,0,1,370.88,249.25Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.67,170a4.33,4.33,0,0,1,0-.66c0-.23,0-.46-.06-.69-.05-.45-.12-.91-.21-1.36a25.6,25.6,0,0,0-.67-2.68,1.57,1.57,0,0,0-.15-.51c-.06-.17-.11-.35-.17-.52-.11-.35-.23-.7-.35-1l-.52-1.5a11.19,11.19,0,0,1-.48-1.45,2.79,2.79,0,0,0-.14-.57.92.92,0,0,1-.09-.25c-.06-.24-.1-.49-.15-.73-.11-.49-.22-1-.35-1.46-.26-1-.56-1.92-.91-2.86-.28-.74-.58-1.47-.91-2.19a7.59,7.59,0,0,0-2.48-3.33,1,1,0,0,0-1-.18c-.34.17-.4.62-.43,1q-.22,3.19-.43,6.41a19.41,19.41,0,0,0,0,4,9.59,9.59,0,0,0,2.2,4.83,18.7,18.7,0,0,0,2.6,2.34c.69.56,1.41,1.1,2.08,1.68A8.94,8.94,0,0,0,371.67,170Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.28,156.47c0-.3-.12-.61-.2-.91a6.06,6.06,0,0,0-.78-1.85c-.18-.29-.27-.61-.44-.9a3.13,3.13,0,0,0-.65-.8,1.19,1.19,0,0,0-.55-.3.55.55,0,0,0-.57.17.83.83,0,0,0-.15.51,18.51,18.51,0,0,1-.68,3.39,13.14,13.14,0,0,1-.58,1.63,2.24,2.24,0,0,1-.31.43,2,2,0,0,0-.18.32,10.26,10.26,0,0,1-.89,1.54,8.26,8.26,0,0,1-.85,1,19.1,19.1,0,0,0-3,3c-1.14,1.79-.95,4.07-1,6.09,0,.35,0,.7,0,1.05,0,2.77-.46,5.17.26,7.9.05.19.25.66.55.48l.31-.2a10.35,10.35,0,0,0,3.1-4.6c.19-.45.36-.91.54-1.37a3.66,3.66,0,0,1,.65-.87c.68-.87,1.25-1.85,1.84-2.78a28.07,28.07,0,0,0,2.94-6,15.16,15.16,0,0,0,.81-4.77A12.1,12.1,0,0,0,384.28,156.47Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.06,178.33c.53,0,1.06,0,1.58,0,1.08,0,2.16,0,3.24,0,.54,0,1.08,0,1.62,0,.19,0,.36,0,.55,0a4.07,4.07,0,0,0,.78,0,.37.37,0,0,0,.15,0,.28.28,0,0,0,.08-.24,4.69,4.69,0,0,0-.52-2.14,4.32,4.32,0,0,0-.61-.92,8.59,8.59,0,0,0-2.79-2.18,14.5,14.5,0,0,0-3.25-1L357.08,170a1.26,1.26,0,0,0-1.17.16,1.09,1.09,0,0,0-.21.64,6.49,6.49,0,0,0,3,5.68A12.44,12.44,0,0,0,365.06,178.33Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.72,189.14a5.17,5.17,0,0,0-1-1.29,6.71,6.71,0,0,0-2.06-1.38,23.52,23.52,0,0,0-4-1.17,46.51,46.51,0,0,1-9-3.22,1.25,1.25,0,0,0-.62-.16c-.51,0-.72.68-.74,1.2a7.47,7.47,0,0,0,3.94,6.89c2.43,1.26,5.32,1.06,8,1h.12a22.35,22.35,0,0,1,2.95.06,9.94,9.94,0,0,1,1.45.22c.4.1,1.14.53,1.39,0a1.09,1.09,0,0,0,0-.62,4.78,4.78,0,0,0-.49-1.45Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.7,189.91a2.1,2.1,0,0,1-.41.31.83.83,0,0,1-.35.1.52.52,0,0,1-.45-.23l-.15-.26a4,4,0,0,1-.25-.56,6.08,6.08,0,0,1-.29-1.19c0-.1,0-.19,0-.29-.06-.45-.09-.91-.14-1.37,0-.23-.05-.45-.09-.68a2.22,2.22,0,0,1,0-.51,3.93,3.93,0,0,0,0-.84,7,7,0,0,1,0-1c.26-3,2.47-5.47,4.28-7.9a37.88,37.88,0,0,0,4.18-7.11c.25-.55.66-1.22,1.26-1.13s.73.6.89,1.06a16.06,16.06,0,0,1-.26,10.09,22.33,22.33,0,0,1-2.77,5.44,29.4,29.4,0,0,1-1.87,2.42c-.2.24-.38.47-.58.69-.63.68-1.27,1.34-1.92,2l-.81.8Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.13,198.29a25.66,25.66,0,0,0-6.24-1.23,14.58,14.58,0,0,1-6.06-1.81,1.06,1.06,0,0,0-.62-.25c-.44,0-.67.53-.72,1a6,6,0,0,0,1,3.73,11.19,11.19,0,0,0,11.16,5.09h0c1.37-.24,2.7-.73,4.1-.87a8.69,8.69,0,0,1,1,0c.22,0,.58.15.75,0,.37-.39-.07-.93-.17-1.33a4.27,4.27,0,0,0-.61-1.34,6.79,6.79,0,0,0-2.12-2.08A9.21,9.21,0,0,0,372.13,198.29Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.27,210.74c-2.1-.53-4.31-.64-6.35-1.36-.91-.33-1.78-.78-2.67-1.14-.26-.1-.58-.19-.77,0a.72.72,0,0,0-.14.46,7.11,7.11,0,0,0,3.21,5.82,11.77,11.77,0,0,0,6.58,1.86c1.38,0,2.77-.12,4.15,0a3.17,3.17,0,0,1,1,.15c.16.07.26.24.42.3.61.21.69-.67.63-1a5.21,5.21,0,0,0-.82-2,4,4,0,0,0-.71-.83,1.19,1.19,0,0,0-.35-.19c-.59-.29-1.09-.79-1.68-1.11A11,11,0,0,0,372.27,210.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,203a8.86,8.86,0,0,1,1.6.8,15.45,15.45,0,0,1,1.45,1.23c.25,3.46.41,6.93.55,10.41a5.41,5.41,0,0,0-.74-.66,6.61,6.61,0,0,0-2.28-1.06c-2-.52-4.17-.22-6.15-.89-.09,0-.14.18-.05.22,1.81.74,3.75.79,5.63,1.24a8,8,0,0,1,2.18.85,4.2,4.2,0,0,1,.89.68,5.71,5.71,0,0,1,.57.75c.23,5.63.48,11.25,1.1,16.85a93,93,0,0,0,1.51,9.55c.33,1.57.73,3.11,1.19,4.65.27.9.56,1.8.89,2.69a13.12,13.12,0,0,0,.86,1.86h1a10.64,10.64,0,0,0-.29-1.27c-.22-.76-.46-1.52-.68-2.28-.4-1.4-.76-2.8-1.08-4.22-.65-2.89-1.17-5.8-1.54-8.74-.75-5.9-1-11.85-1.27-17.79S378.85,206,378.22,200c-.38-3.59-.9-7.17-1.53-10.72a19.08,19.08,0,0,1,2.28-5.09,43,43,0,0,0,3.5-6.39c0-.09-.06-.25-.12-.12-1.14,2.2-2.93,4-4.32,6a14.73,14.73,0,0,0-1.73,3.43c-.34-1.76-.7-3.52-1.11-5.27-.25-1.1-.53-2.19-.81-3.29.09-.61.19-1.21.24-1.83a21.79,21.79,0,0,1,.33-2.25,23,23,0,0,1,1.37-4.29c1.15-2.73,3.11-5.07,4-7.89.05-.15-.12-.36-.2-.16a17.51,17.51,0,0,1-2.56,4.17,19.94,19.94,0,0,0-2.47,4,18.7,18.7,0,0,0-1.27,4.39c-.07.4-.13.8-.18,1.21a103.77,103.77,0,0,0-5.22-14.25c-.07-.16-.2.07-.17.17,1.55,5.11,3,10.25,4.28,15.43l-.28-.19a10.29,10.29,0,0,0-2.25-1.06c-2-.7-4.08-1.17-6.1-1.79-.12,0-.17.27-.06.31,1.88.65,3.75,1.34,5.62,2a16.16,16.16,0,0,1,2.18.95,5.94,5.94,0,0,1,1,.67c.06.06.11.12.17.17,1,4,1.82,8.09,2.51,12.18a9,9,0,0,0-5.09-2.79c-1.39-.27-2.8-.33-4.2-.52a12.8,12.8,0,0,1-3.91-1.22c-.07,0-.1.13-.06.17,1.92,1.75,5,1.82,7.45,2.23a9.87,9.87,0,0,1,3.77,1.28,7.94,7.94,0,0,1,2.29,2.33c.33,2.05.63,4.1.87,6.17.22,1.9.39,3.81.53,5.72a6.48,6.48,0,0,0-2.14-1.5,13.79,13.79,0,0,0-3.72-1.07c-2.59-.42-5.33-.51-7.56-2.08,0,0-.06,0,0,.06,1.86,1.78,4.44,2.26,6.87,2.74A20.46,20.46,0,0,1,374,203Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,203a8.86,8.86,0,0,1,1.6.8,15.45,15.45,0,0,1,1.45,1.23c.25,3.46.41,6.93.55,10.41a5.41,5.41,0,0,0-.74-.66,6.61,6.61,0,0,0-2.28-1.06c-2-.52-4.17-.22-6.15-.89-.09,0-.14.18-.05.22,1.81.74,3.75.79,5.63,1.24a8,8,0,0,1,2.18.85,4.2,4.2,0,0,1,.89.68,5.71,5.71,0,0,1,.57.75c.23,5.63.48,11.25,1.1,16.85a93,93,0,0,0,1.51,9.55c.33,1.57.73,3.11,1.19,4.65.27.9.56,1.8.89,2.69a13.12,13.12,0,0,0,.86,1.86h1a10.64,10.64,0,0,0-.29-1.27c-.22-.76-.46-1.52-.68-2.28-.4-1.4-.76-2.8-1.08-4.22-.65-2.89-1.17-5.8-1.54-8.74-.75-5.9-1-11.85-1.27-17.79S378.85,206,378.22,200c-.38-3.59-.9-7.17-1.53-10.72a19.08,19.08,0,0,1,2.28-5.09,43,43,0,0,0,3.5-6.39c0-.09-.06-.25-.12-.12-1.14,2.2-2.93,4-4.32,6a14.73,14.73,0,0,0-1.73,3.43c-.34-1.76-.7-3.52-1.11-5.27-.25-1.1-.53-2.19-.81-3.29.09-.61.19-1.21.24-1.83a21.79,21.79,0,0,1,.33-2.25,23,23,0,0,1,1.37-4.29c1.15-2.73,3.11-5.07,4-7.89.05-.15-.12-.36-.2-.16a17.51,17.51,0,0,1-2.56,4.17,19.94,19.94,0,0,0-2.47,4,18.7,18.7,0,0,0-1.27,4.39c-.07.4-.13.8-.18,1.21a103.77,103.77,0,0,0-5.22-14.25c-.07-.16-.2.07-.17.17,1.55,5.11,3,10.25,4.28,15.43l-.28-.19a10.29,10.29,0,0,0-2.25-1.06c-2-.7-4.08-1.17-6.1-1.79-.12,0-.17.27-.06.31,1.88.65,3.75,1.34,5.62,2a16.16,16.16,0,0,1,2.18.95,5.94,5.94,0,0,1,1,.67c.06.06.11.12.17.17,1,4,1.82,8.09,2.51,12.18a9,9,0,0,0-5.09-2.79c-1.39-.27-2.8-.33-4.2-.52a12.8,12.8,0,0,1-3.91-1.22c-.07,0-.1.13-.06.17,1.92,1.75,5,1.82,7.45,2.23a9.87,9.87,0,0,1,3.77,1.28,7.94,7.94,0,0,1,2.29,2.33c.33,2.05.63,4.1.87,6.17.22,1.9.39,3.81.53,5.72a6.48,6.48,0,0,0-2.14-1.5,13.79,13.79,0,0,0-3.72-1.07c-2.59-.42-5.33-.51-7.56-2.08,0,0-.06,0,0,.06,1.86,1.78,4.44,2.26,6.87,2.74A20.46,20.46,0,0,1,374,203Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,220.27a21,21,0,0,0-3.11-1.47l-7.08-2.92a1.11,1.11,0,0,0-1-.06,1,1,0,0,0-.33.74,7.53,7.53,0,0,0,.42,3,12,12,0,0,0,9.14,8.23c1.78.27,3.63.07,5.38.48.7.17,1.85.39,1.86-.67a1.46,1.46,0,0,0-.29-.76c-.17-.34-.25-.74-.39-1.1a11.33,11.33,0,0,0-2.5-3.85A11.2,11.2,0,0,0,363.82,220.27Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44,232.27a17.39,17.39,0,0,0-4.45-1.11l-4.08-.64-1.58-.24a.9.9,0,0,1-.22-.06,1.17,1.17,0,0,0-.66-.15c-.31.05-.35.25-.38.52a4.62,4.62,0,0,0,.15,1.61A6,6,0,0,0,358,235a10.29,10.29,0,0,0,4.92,2.25,18.51,18.51,0,0,0,4.4.35c1.23-.05,2.47-.31,3.08-1.51s-.4-2-1.14-2.68A7,7,0,0,0,367.44,232.27Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.09,223.67a1.78,1.78,0,0,1,.08-.86,1,1,0,0,1,1-.5,1.93,1.93,0,0,1,1.06.54c1.26,1.12,1.58,2.94,1.73,4.61a15.62,15.62,0,0,1-.18,5.15c-.3,1.23-.87,2.82-2.27,3.11a2.4,2.4,0,0,1-2.54-1.21c-.79-1.43-.1-3.32.26-4.77a22.68,22.68,0,0,0,.85-5.42C372.1,224.1,372.1,223.89,372.09,223.67Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,241.8a19.41,19.41,0,0,0-5.39-1.19l-2-.25a1,1,0,0,0-.43,0c-.45.14-.48.77-.34,1.21.61,1.93,2.72,3,4.71,3.34s4.08.34,5.94,1.13c.43.18,1.12.48,1.41-.08s-.19-.78-.38-1.14a6.36,6.36,0,0,0-2-2.2A8.65,8.65,0,0,0,369.11,241.8Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.16,239.38c.64-1.58,2-2.86,2.29-4.54a.88.88,0,0,1,.89.39,2.54,2.54,0,0,1,.36,1,18.81,18.81,0,0,1,.62,3.93,6.38,6.38,0,0,1-1,3.79,2.26,2.26,0,0,1-1.64,1.05,1.9,1.9,0,0,1-1.54-.61c-.6-.67-.42-1.65-.38-2.48A7.28,7.28,0,0,1,373.16,239.38Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,236c.55.12,1.09.29,1.63.45q.74,3.87,1.52,7.74c.05.28.11.57.16.85-.14-.11-.28-.22-.43-.32a5.37,5.37,0,0,0-1.27-.63,2.68,2.68,0,0,0-.69-.17l-.66,0c-.16,0-.17.32,0,.35a8.37,8.37,0,0,1,1.28.43,7.32,7.32,0,0,1,1.12.56,6,6,0,0,1,.84.66c.36,1.93.73,3.86,1.2,5.76a19,19,0,0,0,1.19,3.53,9.35,9.35,0,0,0,.55,1h1.26a22.63,22.63,0,0,1-1.57-4.42c-.49-1.95-.86-3.93-1.23-5.91a6.11,6.11,0,0,1,.31-1.26c.17-.45.36-.9.57-1.34l.34-.64a3.16,3.16,0,0,0,.27-1s0-.11-.07-.09c-.55.18-.82.74-1.11,1.21a7.75,7.75,0,0,0-.66,1.28q-.66-3.37-1.34-6.74h0a10.34,10.34,0,0,1,.26-1.1c.23-.72.59-1.37.87-2.06a9.7,9.7,0,0,0,.7-2.28,6.65,6.65,0,0,0,.16-2.22c0-.2-.21,0-.19.13.13.82-.54,1.58-.9,2.26s-.66,1.25-1,1.88c-.15.3-.29.59-.42.9a21.8,21.8,0,0,0-1.79-6.2,10.14,10.14,0,0,0-2.33-2.95,10.92,10.92,0,0,0-1.85-1.25,16.27,16.27,0,0,0-2.22-.88c-.08,0-.12.15-.07.19.57.37,1.09.8,1.65,1.16a15.76,15.76,0,0,1,1.77,1.26,7,7,0,0,1,2,2.74,35.47,35.47,0,0,1,1.63,6.59,16.85,16.85,0,0,0-3.21-.55,9.94,9.94,0,0,1-3.34-1c-.14-.07-.21.25-.11.32a8,8,0,0,0,3.39,1.34C367.54,235.73,368.14,235.85,368.75,236Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,236c.55.12,1.09.29,1.63.45q.74,3.87,1.52,7.74c.05.28.11.57.16.85-.14-.11-.28-.22-.43-.32a5.37,5.37,0,0,0-1.27-.63,2.68,2.68,0,0,0-.69-.17l-.66,0c-.16,0-.17.32,0,.35a8.37,8.37,0,0,1,1.28.43,7.32,7.32,0,0,1,1.12.56,6,6,0,0,1,.84.66c.36,1.93.73,3.86,1.2,5.76a19,19,0,0,0,1.19,3.53,9.35,9.35,0,0,0,.55,1h1.26a22.63,22.63,0,0,1-1.57-4.42c-.49-1.95-.86-3.93-1.23-5.91a6.11,6.11,0,0,1,.31-1.26c.17-.45.36-.9.57-1.34l.34-.64a3.16,3.16,0,0,0,.27-1s0-.11-.07-.09c-.55.18-.82.74-1.11,1.21a7.75,7.75,0,0,0-.66,1.28q-.66-3.37-1.34-6.74h0a10.34,10.34,0,0,1,.26-1.1c.23-.72.59-1.37.87-2.06a9.7,9.7,0,0,0,.7-2.28,6.65,6.65,0,0,0,.16-2.22c0-.2-.21,0-.19.13.13.82-.54,1.58-.9,2.26s-.66,1.25-1,1.88c-.15.3-.29.59-.42.9a21.8,21.8,0,0,0-1.79-6.2,10.14,10.14,0,0,0-2.33-2.95,10.92,10.92,0,0,0-1.85-1.25,16.27,16.27,0,0,0-2.22-.88c-.08,0-.12.15-.07.19.57.37,1.09.8,1.65,1.16a15.76,15.76,0,0,1,1.77,1.26,7,7,0,0,1,2,2.74,35.47,35.47,0,0,1,1.63,6.59,16.85,16.85,0,0,0-3.21-.55,9.94,9.94,0,0,1-3.34-1c-.14-.07-.21.25-.11.32a8,8,0,0,0,3.39,1.34C367.54,235.73,368.14,235.85,368.75,236Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.51,161c1.65-3.48,4.65-6.26,5.87-9.92a1,1,0,0,1,.27-.5.7.7,0,0,1,.92.1,2,2,0,0,1,.45.91,15.29,15.29,0,0,1,.35,8.34,30.28,30.28,0,0,1-1.5,3.64,65.19,65.19,0,0,1-2.82,6.33,12.32,12.32,0,0,1-2.36,3c-.69.64-1.92,1.74-2.67.56a3.19,3.19,0,0,1-.29-1.75c0-.7,0-1.41,0-2.11a27.9,27.9,0,0,1,.4-4.18,17.73,17.73,0,0,1,1.16-4Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.91,174.1a18,18,0,0,0-2.29-5.28l-3.74-6.54c-.09-.17-.22-.36-.42-.37s-.36.18-.47.36c-1.76,2.87-1.69,6.59-.52,9.75a26.4,26.4,0,0,0,5.62,8.33,1.06,1.06,0,0,0,1.13.42,1.49,1.49,0,0,0,.74-1.16,1.61,1.61,0,0,0,0-.44,5.89,5.89,0,0,1,.08-1.26c0-.52.09-1,.1-1.56A11.33,11.33,0,0,0,402.91,174.1Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.6,171.79l3.6-1.79a.46.46,0,0,1,.32-.07c.17,0,.26.24.3.41a5.6,5.6,0,0,1-.64,3.77,12.18,12.18,0,0,1-2.43,3,30.13,30.13,0,0,1-3.05,2.58,28.62,28.62,0,0,1-3.4,2.15,26,26,0,0,1-3.67,1.61,23.32,23.32,0,0,1-3.87,1c-.7.11-1.62.23-1.76-.68a4,4,0,0,1,.72-2.39,10.05,10.05,0,0,1,2.25-2.53,30.43,30.43,0,0,1,3.34-2.52c1.17-.77,2.38-1.47,3.61-2.14s2.49-1.31,3.75-1.94Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.09,185.44a21.92,21.92,0,0,0-1.22-3,52.33,52.33,0,0,1-2.62-7.29c-.4,0-.73.3-1,.63a12.38,12.38,0,0,0-2.64,6.85,9.13,9.13,0,0,0,2.48,6.8c1.27,1.29,3,2.16,3.91,3.73.17.29.34.64.66.74a.46.46,0,0,0,.52-.24c.1-.19-.05-.37,0-.57.07-.63.16-1.25.23-1.88a20,20,0,0,0,.07-3.71A11.65,11.65,0,0,0,396.09,185.44Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.19,190.42c1.87-1.54,4.38-2,6.78-2.28s4.89-.53,7-1.77a1.53,1.53,0,0,1,.75-.3c.7,0,1,.92.87,1.61a6.37,6.37,0,0,1-1.35,2.65,12.22,12.22,0,0,1-2,2.19c-2.65,2.18-6.37,2.37-9.8,2.45l-2.47.06-1.24,0a9.62,9.62,0,0,1-1.2,0c-.63-.06-.13-.81,0-1.1a20.14,20.14,0,0,1,1.07-1.79A8.7,8.7,0,0,1,400.19,190.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.91,199.42a15,15,0,0,0-1.49-2.94q-1.49-2.47-3-4.95c-.31-.52-.72-1.1-1.33-1.12-1.42,3.81-2.2,8.21-.37,11.85a18.22,18.22,0,0,0,2.31,3.29l2.52,3.08c.34.43,1,.87,1.56.57.27-.14.31-.47.36-.73a9.16,9.16,0,0,0,.15-1.27,4.22,4.22,0,0,0,0-.94,13.88,13.88,0,0,1-.21-2.74A12.9,12.9,0,0,0,390.91,199.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.83,201.17a10.74,10.74,0,0,1,2.68-1c1.08-.23,2.21-.24,3.31-.37,1.81-.23,3.57-.79,5.37-1.06a.93.93,0,0,1,.55,0,.89.89,0,0,1,.36.73,6.26,6.26,0,0,1-.94,3.5,12.63,12.63,0,0,1-8.4,6.16,31.68,31.68,0,0,1-4.87.4c-.81,0-1.63.09-2.43.21a12.29,12.29,0,0,0-1.21.23,1.18,1.18,0,0,1-.74.05c-.4-.18-.42-.73-.39-1.1a4.43,4.43,0,0,1,.6-1.65,14.75,14.75,0,0,1,2.43-3.33,14.39,14.39,0,0,1,3.23-2.53Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.59,210.45a34,34,0,0,0-.5,5,16.53,16.53,0,0,0,.9,6.29,22,22,0,0,0,3.8,5.82.64.64,0,0,0,.33.26c.29.07.51-.26.62-.53a14.71,14.71,0,0,0,.82-7.93,14.93,14.93,0,0,0-1.21-3.93c-.26-.57-.65-1.09-.88-1.67-.05-.14-.08-.29-.13-.42a9.23,9.23,0,0,0-.69-1.23,17.26,17.26,0,0,1-1.21-2.75,1.61,1.61,0,0,0-.51-.86.57.57,0,0,0-.59,0c-.21.12-.18.31-.27.5a7.08,7.08,0,0,0-.32.68C382.68,210,382.64,210.2,382.59,210.45Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.85,216.77a9,9,0,0,1,2.6-3,11.54,11.54,0,0,1,2.82-1.21l7.38-2.38a9.1,9.1,0,0,1-2.67,7.49,26.72,26.72,0,0,1-6.32,4.63c-1.63.94-3.3,1.65-4.21,2.26l-1.19.86c-.26.2-.87.72-1.19.37-.16-.16-.06-.46,0-.65s.12-.57.19-.85.2-.71.3-1.07.19-.69.27-1c0-.17.06-.35.1-.52a14.24,14.24,0,0,1,2-4.92Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.14,179.27a60.42,60.42,0,0,0-6.47,3.16c-.41.22-.85.45-1.29.72l.1-.18a64.29,64.29,0,0,0,5.1-10.07,45.26,45.26,0,0,0,2.84-11.18c0-.23-.21-.39-.27-.11-.41,1.75-1,3.45-1.6,5.16s-1.16,3.32-1.85,4.94a74.35,74.35,0,0,1-4.63,9.12c-.23.39-.47.78-.71,1.17,0-.27,0-.54,0-.77a16.54,16.54,0,0,0-.3-3.21,18.65,18.65,0,0,0-.79-2.93,6.63,6.63,0,0,0-1.37-2.71c-.11-.1-.2.08-.18.18a19,19,0,0,0,1,2.67,17.77,17.77,0,0,1,.65,2.89,19.25,19.25,0,0,1,.15,2.94,18.74,18.74,0,0,0-.14,2.59c-1.26,2.09-2.51,4.18-3.64,6.34-.52,1-1,2-1.47,3l0-.13a18.89,18.89,0,0,0-1.22-3.32c-1.11-2.46-2.4-4.87-2.82-7.57,0-.14-.15,0-.15.06a21.32,21.32,0,0,0,1.69,6.77c.43,1.17.82,2.35,1.14,3.56a12,12,0,0,1,.34,1.79c0,.31.06.6.11.89l-.15.36a3,3,0,0,0-.46,1.08c-.33.76-.64,1.53-.94,2.31-1.09,2.81-2,5.67-2.87,8.57a18.14,18.14,0,0,0-.85-3.16,17.72,17.72,0,0,0-1.43-3.06,10.27,10.27,0,0,0-2-2.86c-.11-.09-.15.17-.12.23.43,1,1.1,1.86,1.53,2.86s.8,2,1.11,2.94a45.44,45.44,0,0,1,1.19,5.29,111.22,111.22,0,0,0-2.41,11.86c-.62-1.54-1.42-3-2.19-4.46-.1-.2-.25.1-.2.23a30.63,30.63,0,0,1,1.82,5.61c.07.39.15.78.21,1.17-.55,4.26-.89,8.55-1,12.84,0,.64.07,4.55.15,7a39.24,39.24,0,0,0,.56,6,17.14,17.14,0,0,0,.82,2.9h1.14a12.2,12.2,0,0,0-.2-1.33,53.69,53.69,0,0,1-1-10c0-1.08,0-2.16.05-3.24.07-3.34.28-6.68.6-10a11.82,11.82,0,0,1,1.35-2.62c1.53-2.22,3.88-3.66,5.47-5.81.09-.12.06-.59-.18-.46a26.43,26.43,0,0,0-3.6,2.73,13.94,13.94,0,0,0-2.65,2.72c.25-1.95.53-3.89.87-5.82.38-2.15.83-4.29,1.33-6.41a8.85,8.85,0,0,0,.8-1c.35-.46.69-.93,1.07-1.37a10.88,10.88,0,0,1,2.52-2.11,10.37,10.37,0,0,1,2.72-1.21q.67-.19,1.38-.33a4.56,4.56,0,0,0,1.45-.33c.06,0,.09-.19,0-.23a5.55,5.55,0,0,0-3.49,0,11.52,11.52,0,0,0-3.24,1.3,11.1,11.1,0,0,0-2.42,2.06c.81-3,1.75-5.95,2.84-8.85.64-1.73,1.35-3.42,2.1-5.09a8,8,0,0,1,1.92-1.12,25.59,25.59,0,0,1,2.93-.94,16.23,16.23,0,0,0,2.73-1.1c.12,0,.14-.36,0-.32-1.14.31-2.36.4-3.51.62a15,15,0,0,0-3.14.88c1.12-2.36,2.34-4.68,3.62-7a11.78,11.78,0,0,1,1.41-1.66,17.36,17.36,0,0,1,2.68-1.62c1.92-1.09,3.82-2.15,5.62-3.42C411.35,179.57,411.32,179.2,411.14,179.27Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.14,179.27a60.42,60.42,0,0,0-6.47,3.16c-.41.22-.85.45-1.29.72l.1-.18a64.29,64.29,0,0,0,5.1-10.07,45.26,45.26,0,0,0,2.84-11.18c0-.23-.21-.39-.27-.11-.41,1.75-1,3.45-1.6,5.16s-1.16,3.32-1.85,4.94a74.35,74.35,0,0,1-4.63,9.12c-.23.39-.47.78-.71,1.17,0-.27,0-.54,0-.77a16.54,16.54,0,0,0-.3-3.21,18.65,18.65,0,0,0-.79-2.93,6.63,6.63,0,0,0-1.37-2.71c-.11-.1-.2.08-.18.18a19,19,0,0,0,1,2.67,17.77,17.77,0,0,1,.65,2.89,19.25,19.25,0,0,1,.15,2.94,18.74,18.74,0,0,0-.14,2.59c-1.26,2.09-2.51,4.18-3.64,6.34-.52,1-1,2-1.47,3l0-.13a18.89,18.89,0,0,0-1.22-3.32c-1.11-2.46-2.4-4.87-2.82-7.57,0-.14-.15,0-.15.06a21.32,21.32,0,0,0,1.69,6.77c.43,1.17.82,2.35,1.14,3.56a12,12,0,0,1,.34,1.79c0,.31.06.6.11.89l-.15.36a3,3,0,0,0-.46,1.08c-.33.76-.64,1.53-.94,2.31-1.09,2.81-2,5.67-2.87,8.57a18.14,18.14,0,0,0-.85-3.16,17.72,17.72,0,0,0-1.43-3.06,10.27,10.27,0,0,0-2-2.86c-.11-.09-.15.17-.12.23.43,1,1.1,1.86,1.53,2.86s.8,2,1.11,2.94a45.44,45.44,0,0,1,1.19,5.29,111.22,111.22,0,0,0-2.41,11.86c-.62-1.54-1.42-3-2.19-4.46-.1-.2-.25.1-.2.23a30.63,30.63,0,0,1,1.82,5.61c.07.39.15.78.21,1.17-.55,4.26-.89,8.55-1,12.84,0,.64.07,4.55.15,7a39.24,39.24,0,0,0,.56,6,17.14,17.14,0,0,0,.82,2.9h1.14a12.2,12.2,0,0,0-.2-1.33,53.69,53.69,0,0,1-1-10c0-1.08,0-2.16.05-3.24.07-3.34.28-6.68.6-10a11.82,11.82,0,0,1,1.35-2.62c1.53-2.22,3.88-3.66,5.47-5.81.09-.12.06-.59-.18-.46a26.43,26.43,0,0,0-3.6,2.73,13.94,13.94,0,0,0-2.65,2.72c.25-1.95.53-3.89.87-5.82.38-2.15.83-4.29,1.33-6.41a8.85,8.85,0,0,0,.8-1c.35-.46.69-.93,1.07-1.37a10.88,10.88,0,0,1,2.52-2.11,10.37,10.37,0,0,1,2.72-1.21q.67-.19,1.38-.33a4.56,4.56,0,0,0,1.45-.33c.06,0,.09-.19,0-.23a5.55,5.55,0,0,0-3.49,0,11.52,11.52,0,0,0-3.24,1.3,11.1,11.1,0,0,0-2.42,2.06c.81-3,1.75-5.95,2.84-8.85.64-1.73,1.35-3.42,2.1-5.09a8,8,0,0,1,1.92-1.12,25.59,25.59,0,0,1,2.93-.94,16.23,16.23,0,0,0,2.73-1.1c.12,0,.14-.36,0-.32-1.14.31-2.36.4-3.51.62a15,15,0,0,0-3.14.88c1.12-2.36,2.34-4.68,3.62-7a11.78,11.78,0,0,1,1.41-1.66,17.36,17.36,0,0,1,2.68-1.62c1.92-1.09,3.82-2.15,5.62-3.42C411.35,179.57,411.32,179.2,411.14,179.27Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.88,245.11a14.15,14.15,0,0,0-.5-3.37,7.59,7.59,0,0,0-2.27-4.06,2.94,2.94,0,0,0-2.27-.63c.23,1.6.46,3.21.7,4.81,0,.17,0,.34.08.51a8.5,8.5,0,0,0,1.11,3.51,4.75,4.75,0,0,0,.63.64,7.34,7.34,0,0,0,1.41,1.14l.24.14a.73.73,0,0,0,.38.11c.45,0,.39-.71.42-1a12.24,12.24,0,0,0,.07-1.6Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.55,239.06a13.9,13.9,0,0,0,2.57-1.47c.17-.13.4-.27.59-.16a.54.54,0,0,1,.2.31,4.07,4.07,0,0,1-1.05,3.37,12.9,12.9,0,0,1-3.1,3,9.3,9.3,0,0,1-3.91,1.55c-.83.11-2.66.26-2.3-1.09a4.57,4.57,0,0,1,.8-1.47,14.7,14.7,0,0,1,1.3-1.54c1.2-1.19,2.84-1.65,4.37-2.26Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.77,230.25a13.87,13.87,0,0,1,9,.31,3.88,3.88,0,0,1,1.93,1.19,1.55,1.55,0,0,1-.11,2.07,2.39,2.39,0,0,1-.89.36l-13.93,3.42a3.5,3.5,0,0,1-1.12.11c-.18,0-.34-.12-.51-.15s-.29.06-.39-.11a.65.65,0,0,1-.06-.34,4.11,4.11,0,0,1,.07-.86,1.34,1.34,0,0,1,.14-.38c.16-.3.28-.63.43-.94a9.17,9.17,0,0,1,3.08-3.49A10.26,10.26,0,0,1,402.77,230.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.26,221.91c2.38-1.25,5.18-1.37,7.88-1.46a.61.61,0,0,1,.44.11.47.47,0,0,1,.12.3,4.12,4.12,0,0,1-1.28,3.24,10.51,10.51,0,0,1-3.44,2.54,20.58,20.58,0,0,1-3.93,1.22l-3.61.87c-.24.06-.78.35-1,.18s0-.91.05-1.14a8.32,8.32,0,0,1,.68-1.37,11.49,11.49,0,0,1,1.53-2.44A9,9,0,0,1,405.26,221.91Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2,229.61c-.07-.05-.16-.1-.23-.06a.22.22,0,0,0-.1.17,3,3,0,0,0-.12.58c0,.06,0,.11,0,.16a2.05,2.05,0,0,1-.1.48,5,5,0,0,0-.1,1.09,5.67,5.67,0,0,0,.15,1.16,8.3,8.3,0,0,0,1.12,2.57,4.19,4.19,0,0,0,.4.54c.16.18.35.35.52.52a7.39,7.39,0,0,1,1,1.31c.08.13.19.28.34.26a.39.39,0,0,0,.22-.18,1.58,1.58,0,0,0,.34-.55,5.13,5.13,0,0,0,.13-.66s0-.07,0-.11a8.22,8.22,0,0,0-.42-3.37,8.13,8.13,0,0,0-.71-1.56A8.45,8.45,0,0,0,392.2,229.61Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.41,233.2a6.63,6.63,0,0,0-3.48.07,17.21,17.21,0,0,0-3.67,1.08,9.23,9.23,0,0,0-2,1.25,21.86,21.86,0,0,1,3.21-5.08,25.51,25.51,0,0,1,5.14-4.87c.08-.05.09-.32,0-.27a19.25,19.25,0,0,0-5.25,3.38,19.63,19.63,0,0,0-3.86,5.15,21.26,21.26,0,0,0-1.21,2.72c-.06-.18-.11-.36-.17-.54a9.67,9.67,0,0,0-.76-1.63,4.72,4.72,0,0,0-.51-.75c-.12-.15-.27-.42-.5-.39,0,0-.06.07-.06.11a2.2,2.2,0,0,0,.33.81c.12.22.24.44.35.67a13.12,13.12,0,0,1,.55,1.4c.16.5.25,1,.37,1.52a20.53,20.53,0,0,0-.5,2,27.86,27.86,0,0,0-.43,4c-.11-.28-.22-.56-.35-.84a11.24,11.24,0,0,0-1.36-2.12c-.11-.13-.2.17-.13.27a11.14,11.14,0,0,1,1.66,4.43c.05.28.09.55.14.82,0,.45,0,.9,0,1.35,0,1.64,0,3.27,0,4.91,0,1.15-.13,2.3-.21,3.44h1.08a23.2,23.2,0,0,0,.55-5.86c0-1.52,0-3,0-4.55,0,0,0,0,.07,0a3.31,3.31,0,0,1,.81-.37,11.4,11.4,0,0,0,1.72-.76,11.19,11.19,0,0,0,2.92-2.24c.06-.07,0-.28-.06-.18a6.73,6.73,0,0,1-3.25,1.76c-.63.17-1.26.36-1.89.55l-.29.1c0-.71.06-1.41.13-2.11a20.86,20.86,0,0,1,.66-3.64c.5-.52.88-1.19,1.39-1.7a9.35,9.35,0,0,1,2.36-1.67,16.19,16.19,0,0,1,3-1.12l1.63-.44a4.68,4.68,0,0,1,1.87-.36C406.48,233.45,406.51,233.23,406.41,233.2Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.41,233.2a6.63,6.63,0,0,0-3.48.07,17.21,17.21,0,0,0-3.67,1.08,9.23,9.23,0,0,0-2,1.25,21.86,21.86,0,0,1,3.21-5.08,25.51,25.51,0,0,1,5.14-4.87c.08-.05.09-.32,0-.27a19.25,19.25,0,0,0-5.25,3.38,19.63,19.63,0,0,0-3.86,5.15,21.26,21.26,0,0,0-1.21,2.72c-.06-.18-.11-.36-.17-.54a9.67,9.67,0,0,0-.76-1.63,4.72,4.72,0,0,0-.51-.75c-.12-.15-.27-.42-.5-.39,0,0-.06.07-.06.11a2.2,2.2,0,0,0,.33.81c.12.22.24.44.35.67a13.12,13.12,0,0,1,.55,1.4c.16.5.25,1,.37,1.52a20.53,20.53,0,0,0-.5,2,27.86,27.86,0,0,0-.43,4c-.11-.28-.22-.56-.35-.84a11.24,11.24,0,0,0-1.36-2.12c-.11-.13-.2.17-.13.27a11.14,11.14,0,0,1,1.66,4.43c.05.28.09.55.14.82,0,.45,0,.9,0,1.35,0,1.64,0,3.27,0,4.91,0,1.15-.13,2.3-.21,3.44h1.08a23.2,23.2,0,0,0,.55-5.86c0-1.52,0-3,0-4.55,0,0,0,0,.07,0a3.31,3.31,0,0,1,.81-.37,11.4,11.4,0,0,0,1.72-.76,11.19,11.19,0,0,0,2.92-2.24c.06-.07,0-.28-.06-.18a6.73,6.73,0,0,1-3.25,1.76c-.63.17-1.26.36-1.89.55l-.29.1c0-.71.06-1.41.13-2.11a20.86,20.86,0,0,1,.66-3.64c.5-.52.88-1.19,1.39-1.7a9.35,9.35,0,0,1,2.36-1.67,16.19,16.19,0,0,1,3-1.12l1.63-.44a4.68,4.68,0,0,1,1.87-.36C406.48,233.45,406.51,233.23,406.41,233.2Z",
    style: {
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sofa--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.33,465.22a2.12,2.12,0,0,1-2.11-2l-3.1-44.16c-.17-2.29-1.38-4.47-2.41-5.06l-77-45.39h0a3,3,0,0,0-.25,1.1l-3.11,40.58a2.12,2.12,0,0,1-4.23-.33l3.11-40.58c.17-2.21,1.08-3.85,2.55-4.63a4.17,4.17,0,0,1,4.08.2l77,45.39c2.41,1.39,4.26,4.85,4.51,8.43L326.45,463a2.12,2.12,0,0,1-2,2.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.37,398.17a2.12,2.12,0,0,1-2.11-2L435.15,352c-.16-2.3-1.37-4.47-2.4-5.07l-77-45.38,0,0a3.27,3.27,0,0,0-.26,1.1l-3.1,40.58a2.12,2.12,0,0,1-4.23-.32l3.11-40.58c.17-2.21,1.08-3.86,2.55-4.64a4.15,4.15,0,0,1,4.07.21l77,45.39c2.4,1.38,4.26,4.85,4.51,8.43l3.1,44.16a2.1,2.1,0,0,1-2,2.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.47,417,236.8,367.17c-2.33-1.34-3.67-3.34-3.67-5.48s1.34-4.13,3.67-5.47L340.47,296.3a16,16,0,0,1,14.65,0l84.68,49.8c2.33,1.35,3.67,3.35,3.67,5.48s-1.34,4.13-3.67,5.48L336.12,417a16,16,0,0,1-14.65,0ZM342.64,300,239,360c-.93.54-1.5,1.2-1.5,1.73s.57,1.2,1.5,1.74l84.68,49.8a11.56,11.56,0,0,0,10.32,0l103.68-59.92c.92-.53,1.5-1.2,1.5-1.73s-.58-1.19-1.5-1.73L353,300h0a11.61,11.61,0,0,0-10.32,0ZM354,298.17h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,317.05a1.72,1.72,0,0,0,1.69-1.36l7-32.16a1.73,1.73,0,1,0-3.38-.74l-7,32.16A1.73,1.73,0,0,0,393.6,317,1.61,1.61,0,0,0,394,317.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89,306.62a1.73,1.73,0,0,0,1.69-1.37l7-32.16a1.73,1.73,0,1,0-3.38-.74l-7,32.17a1.74,1.74,0,0,0,1.32,2.06A2.46,2.46,0,0,0,375.89,306.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.54,264a1.75,1.75,0,0,1,1-1.45l9.06-5.23a5.57,5.57,0,0,1,5,0l50.56,29.19a1.75,1.75,0,0,1,1,1.45v2.7a1.74,1.74,0,0,1-1,1.44l-9.06,5.23a5.51,5.51,0,0,1-5,0l-50.56-29.19a1.74,1.74,0,0,1-1-1.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.57,262.52l9.06-5.23a5.57,5.57,0,0,1,5,0l39,22.52V297.9a5.11,5.11,0,0,1-2.5-.6l-50.56-29.19a1.74,1.74,0,0,1-1-1.44V264A1.75,1.75,0,0,1,355.57,262.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,257.29l50.56,29.19a1.53,1.53,0,0,1,0,2.89l-9.06,5.23a5.51,5.51,0,0,1-5,0l-50.56-29.19a1.53,1.53,0,0,1,0-2.89l9.06-5.23A5.57,5.57,0,0,1,369.63,257.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,344.1l107.12-61.92a2.2,2.2,0,0,1,2.21.21L434,330.86a6.87,6.87,0,0,1,3.12,5.41v13.06a2.19,2.19,0,0,1-.91,2L329.09,413.27a2.17,2.17,0,0,1-2.2-.22l-82.33-48.46a6.92,6.92,0,0,1-3.12-5.41V346.12A2.19,2.19,0,0,1,242.35,344.1Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.35,344.1l107.12-61.92a2.2,2.2,0,0,1,2.21.21L434,330.86a6.87,6.87,0,0,1,3.12,5.41v13.06a2.19,2.19,0,0,1-.91,2L329.09,413.27a2.17,2.17,0,0,1-2.2-.22l-82.33-48.46a6.92,6.92,0,0,1-3.12-5.41V346.12A2.19,2.19,0,0,1,242.35,344.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.1,413.26l107.11-61.91a2.22,2.22,0,0,0,.92-2V336.27a6.57,6.57,0,0,0-1.05-3.29L329,394.9a6.53,6.53,0,0,1,1,3.28v13.07A2.17,2.17,0,0,1,329.1,413.26Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.1,413.26l107.11-61.91a2.22,2.22,0,0,0,.92-2V336.27a6.57,6.57,0,0,0-1.05-3.29L329,394.9a6.53,6.53,0,0,1,1,3.28v13.07A2.17,2.17,0,0,1,329.1,413.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330,411.25V398.19a6.92,6.92,0,0,0-3.12-5.41l-82.33-48.46a1.9,1.9,0,0,0-3.12,1.8v13.06a6.92,6.92,0,0,0,3.12,5.41l82.33,48.46a2.17,2.17,0,0,0,2.2.22A2.19,2.19,0,0,0,330,411.25Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.6,260.64,330,205.5a2,2,0,0,1,1.95.28l11.32,6.54a8.7,8.7,0,0,1,3.74,5.35l12.63,72.91c.18,1,0,1.73-.54,2L263.7,347.75a2,2,0,0,1-2-.28l-11.32-6.54a8.7,8.7,0,0,1-3.74-5.35l-12.63-72.91C233.87,261.64,234.09,260.94,234.6,260.64Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.6,260.64,330,205.5a2,2,0,0,1,1.95.28l11.32,6.54a8.7,8.7,0,0,1,3.74,5.35l12.63,72.91c.18,1,0,1.73-.54,2L263.7,347.75a2,2,0,0,1-2-.28l-11.32-6.54a8.7,8.7,0,0,1-3.74-5.35l-12.63-72.91C233.87,261.64,234.09,260.94,234.6,260.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.25,345.72c.17,1,0,1.73-.55,2l95.41-55.15c.5-.29.72-1,.54-2L347,217.67a7.86,7.86,0,0,0-1.4-3.1l-95.4,55.14a7.85,7.85,0,0,1,1.4,3.1Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.25,345.72c.17,1,0,1.73-.55,2l95.41-55.15c.5-.29.72-1,.54-2L347,217.67a7.86,7.86,0,0,0-1.4-3.1l-95.4,55.14a7.85,7.85,0,0,1,1.4,3.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.74,347.47l-11.32-6.54a8.7,8.7,0,0,1-3.74-5.35l-12.63-72.91c-.18-1,0-1.73.55-2a2,2,0,0,1,2,.28l11.33,6.54a8.76,8.76,0,0,1,3.74,5.36l12.63,72.9c.18,1-.05,1.74-.55,2A2,2,0,0,1,261.74,347.47Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cushion--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.6,262.46c-4.36-.44-8,4.59-15.23,8.14-13.54,6.63-19.64,12.65-25.94,20s-8.69,6.11-10.62,10.69,3.4,6.54,5.94,13c4.28,10.95,9.6,18.3,15.14,22.87,9.78,8.05,8.28,13.66,12.73,13.61,4.74-.06,4.4-4.12,11.85-7,17.62-6.84,24.85-12.94,33-25,3.18-4.71,7.23-4.31,8-8.86.38-2.27-2.92-3.49-5.9-10.62-5-11.85-12.87-23-20.58-28.75C286.61,268.05,286,262.9,281.6,262.46Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.6,262.46c-4.36-.44-8,4.59-15.23,8.14-13.54,6.63-19.64,12.65-25.94,20s-8.69,6.11-10.62,10.69,3.4,6.54,5.94,13c4.28,10.95,9.6,18.3,15.14,22.87,9.78,8.05,8.28,13.66,12.73,13.61,4.74-.06,4.4-4.12,11.85-7,17.62-6.84,24.85-12.94,33-25,3.18-4.71,7.23-4.31,8-8.86.38-2.27-2.92-3.49-5.9-10.62-5-11.85-12.87-23-20.58-28.75C286.61,268.05,286,262.9,281.6,262.46Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.61,308.91c3.72,5.28,3.23,10.54,10.88,20.24,7.35,9.31,12.68,11.93,14.88,16.11,1.83,3.47,4.33,5.1,4.93,1s-2.6-15.68-10-25.62c-8.53-11.45-14-15.83-17.65-17.51C231.86,300.52,231.68,304.76,234.61,308.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.76,339.31c-4.86,1.68-5.07,6-7.51,9.32a19.25,19.25,0,0,1,7.22-4.85c8-3.11,13.89-6.08,18.67-9.52C287.92,337.54,279.29,338.09,275.76,339.31ZM306.2,317c-3,2.78-2.71,7.71-6.34,12.48a68.18,68.18,0,0,0,8.6-10.65c2.9-4.3,6.53-4.35,7.72-7.79C313.51,314.39,309.83,313.63,306.2,317Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.54,273c-10.38,1.94-20.75,7.29-27.89,15.27a8.3,8.3,0,0,0-1.9,6,8.07,8.07,0,0,0,4.19,6.56c2.44,1.38,6,1.39,8.56,1.06,5.37-.69,8.53-2.09,15.48-2.2a15.9,15.9,0,0,1,7.32,1.85c3.42,1.9,6,4.06,9,5.66,4.13,2.22,11.47,1.21,14-1.34,2.72-2.73,3.33-6.82.89-11.95C299.78,282.49,289.69,271.39,275.54,273Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cushion--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.53,248.07c3.79-2.19,9.16.89,17.24,1.13,15.07.44,26.94,3.68,35.71,7.76s10.44,2,14.08,5.35-.39,7.36,0,14.33c.63,11.74-1.18,20.63-4.34,27.08-5.58,11.37-1.9,15.86-6,17.65-4.34,1.91-5.71-1.93-13.69-1.49-18.87,1-31.81-1.8-44.2-9.4-4.84-3-8.36-.94-10.94-4.76-1.29-1.92,1.22-4.39,1-12.12-.38-12.84,2.23-26.23,6.87-34.68C334.29,255.24,332.68,250.31,336.53,248.07Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.53,248.07c3.79-2.19,9.16.89,17.24,1.13,15.07.44,26.94,3.68,35.71,7.76s10.44,2,14.08,5.35-.39,7.36,0,14.33c.63,11.74-1.18,20.63-4.34,27.08-5.58,11.37-1.9,15.86-6,17.65-4.34,1.91-5.71-1.93-13.69-1.49-18.87,1-31.81-1.8-44.2-9.4-4.84-3-8.36-.94-10.94-4.76-1.29-1.92,1.22-4.39,1-12.12-.38-12.84,2.23-26.23,6.87-34.68C334.29,255.24,332.68,250.31,336.53,248.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.35,271.24c-1.21,6.34,1.41,10.93-1.55,22.93-2.85,11.52-6.62,16.1-6.9,20.82-.23,3.91-1.84,6.43-4.06,3s-4.11-15.35-1.47-27.47c3-13.95,6.18-20.19,8.85-23.24C401.39,262.47,403.3,266.25,402.35,271.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,318.92c5.78,1.16,12.34,1.43,20.94,1a19.25,19.25,0,0,1,8.58,1.42c-3.6-2-5.57-5.86-10.7-5.38C373.71,316.27,365.62,319.33,358.6,318.92Zm-33.5-12.35c2.5,2.64,5.82,1.19,10.24,3.91a68.24,68.24,0,0,0,12.23,6.14c-5.27-2.84-7-7.46-10.92-8.74C332,306.33,328.92,308.55,325.1,306.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.39,255.12c10.25-2.52,24-2.44,33.77,1.89,1.89.92,5.27,3.36,6,5.47a8.06,8.06,0,0,1-1.11,7.71c-1.65,2.26-4.9,3.74-7.35,4.5-5.18,1.59-10.44,1-17.21,3.39a21.3,21.3,0,0,0-7.53,5.43c-2.33,3.15-3.77,6.17-5.84,8.87-2.85,3.73-10,5.83-13.32,4.56-3.61-1.35-5.85-4.83-5.75-10.5C328.25,273.83,332.86,259.55,346.39,255.12Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.63,355.81l8.81-17.35,17.72,10.37-21.85,25.79s-10.83-1-12.57-6.65S356.65,357.68,359.63,355.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.63,355.81l-1.08,2a15.46,15.46,0,0,0,5.62,7.11c4.24,2.92,6.09,2.68,6.09,2.68l1-1.16s.6.52-1,2.28a28.4,28.4,0,0,0-5.1,7.19c-2,3.88-3.52,13-3.71,19.59s.77,11.3-4.34,13.19-10.31-2.82-13.18-7.17-3.88-11-3.18-15.76,4.37-7.87,3.68-13.42c-.5-4.08.16-8.11,2-10.09s5.56-2.51,8.08-3.89S358.62,355.28,359.63,355.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.42,399.55c-3.34-6.38-14.68-8.18-20.34-5.42a20.85,20.85,0,0,0,2.85,7.38c2.87,4.36,8.07,9.06,13.18,7.18C361.1,407.21,361.39,404,361.42,399.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.91,359.07c-2.32.92-5,1.58-6.51,3.18-1.81,2-2.47,6-2,10.09,0,.18,0,.35.05.52h0C349.82,371.21,354.65,363.25,352.91,359.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,295.45s46.76-7.82,64.63-7.7c18.23.11,19.93,13.8,15.36,22.19-8.73,16.05-33.94,44.2-33.94,44.2s-14-1.89-17.15-10.71l5.57-12.77-21.8,7-11.13-7.47L332,326.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.88,343.73s9.53,3.82,13.94,5a73.48,73.48,0,0,0,7.47,1.68L386,366.11l-23-2.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.27,349.63c1.68.49,3,5.73,2.37,9.13-.49,2.63-2.58,6.86-4.24,7l-1.62-.18s.19,1.06,2.8,1.16,10.59,1.12,13.6,1.33,9.45,2.48,13.36,2.92,7.7,1.47,13.86-1.5,9.88-9.85,6.92-15.08-9.45-5.85-14.74-5.75-14.21,2.17-20.09,1.78a66,66,0,0,1-11.57-1.68,3,3,0,0,0-2.77.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.32,354.38C429,350.24,424.41,349,420,348.7c2.94,2,3.81,17.86-2.82,22.76a18.88,18.88,0,0,0,7.23-2C430.55,366.49,434.28,359.61,431.32,354.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66,344.09c-12-6.17-29.55-16.22-36.82-18l-.57-.13c3.28-8,5.48-15.06,1.75-30.51l-65.78,11.14s.42,22.29,6.59,32.8,13.21,14.5,24.06,18.48c9.26,3.4,26.35,2.23,26.35,2.23,3.36,1.91,8,3.17,13.61,3.63,7.11.59,20.34.63,28.06,1.07C373.62,359.07,373.36,345,371.66,344.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.14,317.13a156.62,156.62,0,0,0-9.21,15.3l5.57-1.78c6.28-14.95,7.57-19.31,17.6-26.32C388.1,304.33,380.9,307,374.14,317.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.46,356.41a8.09,8.09,0,0,0,1.36,3.81c1.51-.06,2.42-.12,2.42-.12l.08,0A20.47,20.47,0,0,1,323.46,356.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.87,331.1c5,2.32,8.54,4.39,8.54,4.39l3.79-1.22s-9.27-4.71-16.31-8.21c-1-.49-4.36-2.18-5.24-2.68a29.24,29.24,0,0,0,.32-13.51,37,37,0,0,1-2.51,13.06c-2.79-.77-5.09-.57-9.1.1-7,1.17-27.26,4.62-27.26,4.62s19.42-2,29.53-2.14a21.92,21.92,0,0,1,5.65.45C339.82,327.43,344.17,329.86,346.87,331.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Arm--inject-256",
    d: "M316.36,227.94c7.91,0,15.84,3.74,16.67,12.76.73,8-.34,28.38-.34,28.38l16.91,12.73-9.36,11.71s-16.59-8-22.32-11c-8.76-4.54-7.72-6.37-7.25-17.35S316.36,227.94,316.36,227.94Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.5,268.87c1.47-21.5,2.16-27.37,6.88-34.41,8.83-4.34,25.91-6.25,40-6.52,4.61,4.43,17.15,12.07,21.09,21a18.37,18.37,0,0,1-5.36,21.16c.1,6.4,0,15.19,0,15.19s2.54,4.48,6.1,9.79c-1,10.57-13,21.27-31.87,26.38a50.42,50.42,0,0,1-36-3.71S268,290.17,269.5,268.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.89,271.64s-5.1,6.85-15.81,6.1c-11.06-.78-13.58-9.8-13.58-9.8s0,12,13.24,12.89A15.89,15.89,0,0,0,319.89,271.64Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.75,329.26v1.19a3.37,3.37,0,0,0,1.67,2.91l32,18.4a3.31,3.31,0,0,0,1.68.45,3.35,3.35,0,0,0,1.67-.45l58.68-33.87a3.36,3.36,0,0,0,1.68-2.91v-.82l-62,35.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.12,314.16l-34.79-20.08a2,2,0,0,0-2,0L307,328.93a.44.44,0,0,0,0,.77L342.09,350Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.77 347.03 323 336.2 377.87 304.52 396.73 315.29 341.77 347.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.54 316.92 332.89 317.12 342.09 322.43 358.44 312.98 358.78 312.79 349.24 307.28 332.54 316.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.89 317.12 342.09 322.43 358.44 312.98 349.24 307.68 332.89 317.12",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,350v2.23a3.35,3.35,0,0,0,1.67-.45l58.68-33.87a3.36,3.36,0,0,0,1.68-2.91v-.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.09,350v2.23a3.35,3.35,0,0,0,1.67-.45l58.68-33.87a3.36,3.36,0,0,0,1.68-2.91v-.82Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,281.81a31.51,31.51,0,0,0,10.52,6.11c7.22,2.52,8.71,2.46,14.37,6.75a47.86,47.86,0,0,1,5.5,5.14c1.67,2.89,4,5.36,5.84,8.12,1.51,1.65-.34,2.13-1.79,1.9-4-.82-6.41-4.63-9.64-6.74a13.56,13.56,0,0,1-.26,4.07c-.23,1.07-.28,2.41-1.39,3a8.32,8.32,0,0,1-2.43.42,1.68,1.68,0,0,1-.67.94,2.73,2.73,0,0,1-2,.06,7.55,7.55,0,0,1-1-.4,2,2,0,0,1-1.54,1.27,8.76,8.76,0,0,1-4.58-.85c-.21-.14-1.7-1.43-2.14-1.8-.63-.53-1.22-.88-1.43-1.42s1.07-1.69,2-1.63a9.09,9.09,0,0,1,2.85.83,10.3,10.3,0,0,1-.3-2.68c-.5-1.44-6.48-1.42-11.34-3.42-3.67-1.5-5.19-5-6.8-6q-1.49-1-3.06-1.92",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,350.47a4,4,0,0,0,3.43-.26l58.41-33.73a4,4,0,0,0,1.94-2.78l6.39-38.14a3.49,3.49,0,0,0,.05-.65,4,4,0,0,0-1.17-2.82l-60.71,35.05a3,3,0,0,0-1.43,2.06Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343,350.47a4,4,0,0,0,3.43-.26l58.41-33.73a4,4,0,0,0,1.94-2.78l6.39-38.14a3.49,3.49,0,0,0,.05-.65,4,4,0,0,0-1.17-2.82l-60.71,35.05a3,3,0,0,0-1.43,2.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,350l.4.23a3.36,3.36,0,0,0,.54.26l6.91-41.27a3,3,0,0,1,1.43-2.06l60.71-35.05a3.86,3.86,0,0,0-.81-.62l-60.83,35.12a3,3,0,0,0-1.43,2.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,315.27c.43-2.56,3.07-5.95,5.89-7.58s4.77-.88,4.34,1.67-3.07,5.95-5.89,7.58S375.51,317.82,375.93,315.27Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.17,288.89c1.44-15.62,3-28.53,5.7-39.89,1.59-6.69,3.91-11.87,13.83-14.69,8.8,5.25,6.78,24.07,6,28.51l-4.42,26.88s7.58,5.16,15.61,10.11c6.79,4.18,11.34,6.66,19,6.94s10.68-.22,14.77,1.18c2.17.74,7.14,2.47,8.84,3.17s4.87,3.41,7.74,5.18c2.72,1.83-.37,3.21-2.4,2.79a25.06,25.06,0,0,1-6.18-2.4,34.38,34.38,0,0,0-5.27-1.53A30,30,0,0,1,331.9,321c.1,1.09.44,2.39-.44,3.27a8.61,8.61,0,0,1-2.2,1.12,1.67,1.67,0,0,1-.37,1.09,2.75,2.75,0,0,1-1.89.66,8.55,8.55,0,0,1-1.12-.08,2,2,0,0,1-1.1,1.67,8.8,8.8,0,0,1-4.63.54c-.23-.08-2-.87-2.56-1.09a4.64,4.64,0,0,1-1.8-.94c-.42-.53.53-1.93,1.41-2.14a9.06,9.06,0,0,1,3-.05,10.31,10.31,0,0,1-1.07-2.47c-.91-1.23-6.61.56-11.85.08-3.95-.36-7.07-3.83-8.88-4.48-11.63-4.14-20.48-7-32.36-12.89C255.15,299.89,256.42,297,257.17,288.89Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,315.4c-.72-1.42-1.78-3.1-2.94-3.41a12.85,12.85,0,0,1,1.9,3.15C330.68,315.24,331,315.32,331.37,315.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.26,325.39a12.42,12.42,0,0,0-.16-3.22,27.85,27.85,0,0,0-.68-3.14,13.65,13.65,0,0,0-1.12-3,5.92,5.92,0,0,0-2.13-2.41,4.66,4.66,0,0,1,1,1.23,9.15,9.15,0,0,1,.72,1.39,21,21,0,0,1,1,3c.28,1,.54,2.05.8,3.08A27.35,27.35,0,0,1,329.26,325.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.88,327.06a15.12,15.12,0,0,0-.26-3.15,26.5,26.5,0,0,0-.72-3.08,21.24,21.24,0,0,0-1.11-3,6,6,0,0,0-1.83-2.57,3.93,3.93,0,0,1,.82,1.3c.21.48.4,1,.57,1.45.34,1,.67,2,1,3C324.9,323,325.46,325,325.88,327.06Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.2,325.1a5.13,5.13,0,0,1,1.32.08c.43.06.74.25,1.28.38l-.24-.33a1.32,1.32,0,0,0,.14.62,1.54,1.54,0,0,0,.33.46,1.82,1.82,0,0,0,.94.51,4.48,4.48,0,0,1-.6-.77,2.28,2.28,0,0,1-.17-.4,1.27,1.27,0,0,1,0-.36v-.24l-.25-.08a3.84,3.84,0,0,0-1.25-.16A2.65,2.65,0,0,0,317.2,325.1Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320,174.35c-4.92-6.57-22-8.69-32.34-.72-4.58,3.52-9.85,10.22-7.28,22.36-1.09,2-3.58,4.84-4.46,9.26-1,5-.36,10.25,2.83,14.14s11.75,6.89,22.2,7.59c19.42,1.3,24.78-2.51,28-12.73,2.27-7.22-1.87-15.58-1.87-15.58C329.31,186.05,324.27,177.32,320,174.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.11,183.85c2,1.5,5.4,4.3,3.22,16.08-.3,1.65.22,3,0,6.81-.59,11-5.46,15.49-8.9,16.65-2,.69-4.55.7-8.84.14l-.95,4.88s14.13,13.61,3.92,16.36C299.35,248.33,288,231.23,288,231.23l2.63-21.11c-1.72,1.26-5.51,1.31-7.66-2.84s-1.6-9.65,1.85-11.06c3.77-1.54,5.81.41,7.28,3.5,1.19,2.8,4.48,2.23,4-4.05,3.83-1.34,5.38-5.31,4.94-11.29,2-1.44,5.14,1.77,14.91,2C319.8,186.4,321.22,185.27,324.11,183.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38,206.74a1.79,1.79,0,1,0,2.06-1.47A1.79,1.79,0,0,0,286.38,206.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.61,223.53c-10.47-2.5-16.27-6.89-17.25-11.17,0,0,.54,5.58,3.44,8.1,4.06,3.53,13.23,6,13.23,6Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.6,213.72,309.19,212a2.71,2.71,0,0,0,1.72,3.54A3,3,0,0,0,314.6,213.72Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.13,215.64a2.84,2.84,0,0,1-1.22-.11,2.69,2.69,0,0,1-1.86-2.2A3.26,3.26,0,0,1,312.13,215.64Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,195.09l-4.64-1.57a2.34,2.34,0,0,1,3-1.56A2.55,2.55,0,0,1,327.2,195.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.47,198.66c-1.55,0-2.34,1.13-3,.9a1.24,1.24,0,0,0,1,.75,2.48,2.48,0,0,0,0,.27,2,2,0,1,0,2-1.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.79,199.41h0a1.61,1.61,0,0,0-.44-.06,2,2,0,1,0-.09,3.92,2,2,0,0,0,2-1.76,1.27,1.27,0,0,0,1.16-.48C325.77,201.1,325.3,199.76,323.79,199.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,194.68l4.67-1.69a2.39,2.39,0,0,0-3.11-1.52A2.59,2.59,0,0,0,304,194.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,207.9a5.48,5.48,0,0,1-4.14-1.81,5.62,5.62,0,0,1-1.34-4.43,7,7,0,0,1,6.72-6.06,5.47,5.47,0,0,1,4.11,1.77,5.6,5.6,0,0,1,1.38,4.37h0A7,7,0,0,1,323,207.9Zm1.24-11.51a6.15,6.15,0,0,0-5.93,5.36,4.81,4.81,0,0,0,1.15,3.81A4.66,4.66,0,0,0,323,207.1a6.13,6.13,0,0,0,5.94-5.44,4.79,4.79,0,0,0-1.18-3.75A4.65,4.65,0,0,0,324.25,196.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.34,199.35l.55,10.65,6.48-1.42S318.34,200.49,314.34,199.35Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53,207.43a5.42,5.42,0,0,1-4.14-1.81,5.55,5.55,0,0,1-1.34-4.43,7,7,0,0,1,6.71-6.06,5.49,5.49,0,0,1,4.12,1.77,5.59,5.59,0,0,1,1.37,4.37h0A6.93,6.93,0,0,1,307.53,207.43Zm1.23-11.51a6.15,6.15,0,0,0-5.92,5.36,4.79,4.79,0,0,0,1.14,3.81,4.63,4.63,0,0,0,3.55,1.54,6.13,6.13,0,0,0,5.93-5.44h0a4.76,4.76,0,0,0-1.17-3.75A4.69,4.69,0,0,0,308.76,195.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.12,202.06l-.75-.25c.52-1.58,2.73-2.09,4-1.73a1.23,1.23,0,0,1,1,1.51l-.77-.2c0-.1.1-.38-.46-.55C316.18,200.57,314.48,201,314.12,202.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,200.36l-.07.8-10.83-2.33c-.17-.29-.36-.6-.54-.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5,182.69c-.68,4.29-1.16,10-1.16,10s5.81,2.6,8.2,2.25a41.48,41.48,0,0,0,1.81-9.84,29.26,29.26,0,0,1,1,10c2.15,1,8.58,2.15,11.93,1.25a79.61,79.61,0,0,0,.73-10.86s2.53,5.4,2.33,10.22a13.17,13.17,0,0,0,6.36-1.18s1.93-11.08-6.76-18c-6.53-5.18-16.74-3.63-19.89-1.24A10.45,10.45,0,0,0,299.5,182.69Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,386.56a2.07,2.07,0,0,0,.49-.07,1.73,1.73,0,0,0,1.17-2.15l-7-24a1.73,1.73,0,1,0-3.32,1l7,24.05A1.73,1.73,0,0,0,273.47,386.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.39,376.12a2.07,2.07,0,0,0,.49-.07,1.73,1.73,0,0,0,1.17-2.15l-7-24a1.73,1.73,0,1,0-3.32,1l7,24.05A1.73,1.73,0,0,0,255.39,376.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.22,337.4a1.76,1.76,0,0,1,1-1.44l9.06-5.23a5.49,5.49,0,0,1,5,0l50.56,29.19a1.76,1.76,0,0,1,1,1.44v2.71a1.76,1.76,0,0,1-1,1.44l-9.06,5.23a5.49,5.49,0,0,1-5,0l-50.56-29.19a1.76,1.76,0,0,1-1-1.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.26,336l9.06-5.23a5.49,5.49,0,0,1,5,0l39,22.52v18.09a5.08,5.08,0,0,1-2.5-.6l-50.56-29.19a1.76,1.76,0,0,1-1-1.44V337.4A1.76,1.76,0,0,1,228.26,336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.31,330.73l50.56,29.19a1.52,1.52,0,0,1,0,2.89L283.81,368a5.55,5.55,0,0,1-5,0l-50.56-29.19a1.52,1.52,0,0,1,0-2.89l9.06-5.23A5.49,5.49,0,0,1,242.31,330.73Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.21,392.63a3.47,3.47,0,0,0-3.11,0,1.11,1.11,0,0,0-.65.9l.65,55.65h0a.8.8,0,0,0,.45.62,2.46,2.46,0,0,0,2.21,0,.78.78,0,0,0,.45-.62h0l.65-55.65A1.09,1.09,0,0,0,206.21,392.63Zm-32-3.93a3.43,3.43,0,0,0-3.12,0,.91.91,0,0,0-.52.9l-4.31,46.86h0a.93.93,0,0,0,.54.62,2.45,2.45,0,0,0,2.21,0,.64.64,0,0,0,.36-.62h0L175,389.6A1.33,1.33,0,0,0,174.2,388.7Zm63.88.9a.91.91,0,0,0-.52-.9,3.43,3.43,0,0,0-3.12,0,1.33,1.33,0,0,0-.77.9l5.6,46.86h0a.64.64,0,0,0,.36.62,2.45,2.45,0,0,0,2.21,0,.93.93,0,0,0,.54-.62h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,372.21H254c0-7.3-4.77-14.59-14.42-20.16-19.27-11.13-50.53-11.13-69.81,0-9.64,5.57-14.43,12.86-14.42,20.16h0v3.92h0c.11,7.19,4.94,14.37,14.46,19.87,19.28,11.13,50.54,11.13,69.81,0,9.52-5.5,14.35-12.67,14.47-19.87h0Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,372.21H254c0-7.3-4.77-14.59-14.42-20.16-19.27-11.13-50.53-11.13-69.81,0-9.64,5.57-14.43,12.86-14.42,20.16h0v3.92h0c.11,7.19,4.94,14.37,14.46,19.87,19.28,11.13,50.54,11.13,69.81,0,9.52-5.5,14.35-12.67,14.47-19.87h0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.75,352.05c-19.28,11.13-19.28,29.18,0,40.31s50.54,11.13,69.82,0,19.28-29.17,0-40.31S189,340.92,169.75,352.05Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.75,352.05c-19.28,11.13-19.28,29.18,0,40.31s50.54,11.13,69.82,0,19.28-29.17,0-40.31S189,340.92,169.75,352.05Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.47,362.83c5.4,3.12,5.4,8.18,0,11.3s-14.17,3.12-19.58,0-5.4-8.18,0-11.3S186.06,359.71,191.47,362.83Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.07,369.18c-4.71-4.81-7.47-16.8-2.88-20.61h23.36c4.59,3.81,1.83,15.79-2.87,20.6l-.13.13-.17.16a5.14,5.14,0,0,1-.42.38l-.11.09-.36.27c-.2.14-.4.27-.61.39a15.53,15.53,0,0,1-14,0h0a7.2,7.2,0,0,1-.62-.4l-.33-.25-.13-.11a5,5,0,0,1-.42-.36l-.18-.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,347c5.33,3.08,5.33,8.07,0,11.15s-14,3.08-19.3,0-5.33-8.07,0-11.15S186.19,344,191.52,347Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.74,349.21c3.25,1.88,3.25,4.91,0,6.79A13,13,0,0,1,176,356c-3.25-1.88-3.25-4.91,0-6.79A13,13,0,0,1,187.74,349.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,352.43a13,13,0,0,1,11.74,0,5.41,5.41,0,0,1,1.95,1.78,5.43,5.43,0,0,1-1.95,1.79A13,13,0,0,1,176,356a5.39,5.39,0,0,1-1.94-1.79A5.37,5.37,0,0,1,176,352.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,354.21a26.72,26.72,0,0,0,4.25-5.64c2-3.47,3.63-7.88,2.62-8.46s-6.46,3.83-6.46,3.83a25.14,25.14,0,0,0,.44-5.92c-.18-3.09-.93-5.9-1.81-6.47s-2.87,3.34-3.72,6.16-1.19,4.58-1.19,4.58-.74-3.25-1.69-5.93c-1-2.94-2-3.6-2.68-3.31s-1.21,1.66-1.42,5.56a38,38,0,0,0,.18,5.59s-1.46-1.6-3.07-3.15c-1.78-1.7-3-1.7-3.54-1.38s-.15,2.74,2.6,7.72a27.69,27.69,0,0,0,5.18,6.82S180.53,356.67,187,354.21Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187,354.21a26.72,26.72,0,0,0,4.25-5.64c2-3.47,3.63-7.88,2.62-8.46s-6.46,3.83-6.46,3.83a25.14,25.14,0,0,0,.44-5.92c-.18-3.09-.93-5.9-1.81-6.47s-2.87,3.34-3.72,6.16-1.19,4.58-1.19,4.58-.74-3.25-1.69-5.93c-1-2.94-2-3.6-2.68-3.31s-1.21,1.66-1.42,5.56a38,38,0,0,0,.18,5.59s-1.46-1.6-3.07-3.15c-1.78-1.7-3-1.7-3.54-1.38s-.15,2.74,2.6,7.72a27.69,27.69,0,0,0,5.18,6.82S180.53,356.67,187,354.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182.35,337.71c-.85,2.82-1.19,4.58-1.19,4.58h0l.52,2.43s.53-5.32,1.28-8.74C182.73,336.57,182.52,337.16,182.35,337.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.48,342a35.33,35.33,0,0,1-.75-6.77,26.23,26.23,0,0,0-.36,3.41,38,38,0,0,0,.18,5.59l3.75,3.94A33.64,33.64,0,0,1,176.48,342Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.08,346.25l2.36-2.31h0a25.14,25.14,0,0,0,.44-5.92,20.83,20.83,0,0,0-.48-3.5,16.52,16.52,0,0,1-.28,5.68A52.08,52.08,0,0,1,185.08,346.25Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-256",
    cx: 225.51,
    cy: 378.08,
    rx: 20.56,
    ry: 11.87,
    style: {
      fill: "#8E4DFE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plate--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.49,368.11c-7.72-4.46-20.23-4.46-28,0-3.86,2.22-5.79,5.14-5.79,8.06V377c0,2.92,1.93,5.84,5.79,8.07,7.72,4.45,20.23,4.45,28,0,3.85-2.23,5.78-5.15,5.78-8.07v-.82C245.28,373.26,243.35,370.34,239.49,368.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,386.94V365.41a24.65,24.65,0,0,0-7.41,2.7c-3.86,2.22-5.79,5.14-5.79,8.06V377c0,2.92,1.93,5.84,5.79,8.07a25.8,25.8,0,0,0,9.06,3C219,387.78,219,386.94,219,386.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.49,368.11c-7.72-4.46-20.23-4.46-28,0s-7.72,11.68,0,16.13,20.23,4.46,28,0S247.2,372.56,239.49,368.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.75,370.68c-5.66-3.26-14.82-3.26-20.47,0s-5.66,8.55,0,11.82,14.81,3.26,20.47,0S241.4,373.94,235.75,370.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,372c-4.95-2.86-13-2.86-17.94,0s-4.95,7.5,0,10.36,13,2.86,17.94,0S239.43,374.83,234.48,372Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.42,383.58a23.31,23.31,0,0,0,5.19,2,31.5,31.5,0,0,0,5.47.88,36.46,36.46,0,0,0,5.53,0,32.43,32.43,0,0,0,5.45-.89,24.2,24.2,0,0,0,5.16-1.9,13.93,13.93,0,0,0,4.33-3.3,8,8,0,0,0,1.39-2.33,6.21,6.21,0,0,0,.41-2.67,6.73,6.73,0,0,0-.74-2.62,8,8,0,0,0-.73-1.18,10,10,0,0,0-.88-1.07,11.47,11.47,0,0,1,.95,1,9,9,0,0,1,.78,1.16,7,7,0,0,1,.88,2.67,6.72,6.72,0,0,1-.34,2.81,8.39,8.39,0,0,1-1.4,2.47,11.47,11.47,0,0,1-2,2,16.54,16.54,0,0,1-2.38,1.52,23.82,23.82,0,0,1-5.26,2,33.23,33.23,0,0,1-11.15.81,30.32,30.32,0,0,1-5.5-1,27.43,27.43,0,0,1-2.63-.94A19.44,19.44,0,0,1,211.42,383.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.63,372.2a15.72,15.72,0,0,0-14.23,0c-3.93,2.27-3.93,5.95,0,8.22a15.72,15.72,0,0,0,14.23,0C236.56,378.15,236.56,374.47,232.63,372.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.6,379l-12.95-7.18-13.9,4.38c0,2.91,1.94,5.82,5.79,8a24.65,24.65,0,0,0,7.41,2.7Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mug--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.09,367.78c0,3,2.91,4.6,5.16,5.54,1.68.71,3,.95,3.84,1.67l-2-10.7a4.76,4.76,0,0,0-2.7-.71,3.53,3.53,0,0,0-1.65.46l-1,.6A3.35,3.35,0,0,0,205.09,367.78Zm3-.6a1.84,1.84,0,0,1,.44-1.18,2,2,0,0,1,.35,0,3.06,3.06,0,0,1,2.2.86,29.26,29.26,0,0,1,1.21,4.36l-.29-.12C209.17,369.89,208.07,368.69,208.07,367.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.09,367.78c0,3,2.91,4.6,5.16,5.54,1.68.71,3,.95,3.84,1.67a61.65,61.65,0,0,0-3.05-10.1,4.82,4.82,0,0,0-2.71-.71A3.27,3.27,0,0,0,205.09,367.78Zm1.94,0a1.82,1.82,0,0,1,1.83-1.81,3.06,3.06,0,0,1,2.2.86,25.8,25.8,0,0,1,1.35,5.4c-.48-.17-.94-.33-1.47-.56C208.13,370.49,207,369.29,207,367.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.77,371.6a15.09,15.09,0,0,0,1.3,2.41,6.67,6.67,0,0,1,2,1,61.65,61.65,0,0,0-3.05-10.1,4.76,4.76,0,0,0-1.44-.59V366a3.11,3.11,0,0,1,1.46.79,25.8,25.8,0,0,1,1.35,5.4c-.48-.17-.94-.33-1.47-.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,362.84c0-2.17-1.43-4.34-4.3-6-5.73-3.32-15-3.32-20.76,0-2.87,1.65-4.3,3.82-4.3,6h0V366a14.68,14.68,0,0,0,14.68,14.68h0A14.68,14.68,0,0,0,240.4,366v-3.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.72,354.49A21,21,0,0,1,236,357c2.73,1.57,4.24,3.66,4.24,5.88V366a14.56,14.56,0,0,1-29.12,0v-3.19c0-2.22,1.51-4.31,4.24-5.88a21,21,0,0,1,10.32-2.47m0-.13a21.14,21.14,0,0,0-10.38,2.49c-2.87,1.65-4.3,3.82-4.3,6V366a14.68,14.68,0,0,0,14.68,14.68h0A14.68,14.68,0,0,0,240.4,366v-3.19c0-2.17-1.43-4.34-4.3-6a21.14,21.14,0,0,0-10.38-2.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14,378.46c-6.14-2.62-5.89-7.5-3.85-7.27a31.82,31.82,0,0,0,10.78,0l.05-13.54-14.69.53a6.25,6.25,0,0,0-2.39,4.64V366a14.68,14.68,0,0,0,14.68,14.68h0a14.67,14.67,0,0,0,9.43-3.42A14.68,14.68,0,0,1,221.14,378.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.1,356.85c-5.73-3.32-15-3.32-20.76,0s-5.74,8.67,0,12,15,3.32,20.76,0S241.84,360.16,236.1,356.85Zm-.44,11.21a22.11,22.11,0,0,1-19.88,0c-2.48-1.43-3.85-3.29-3.85-5.22s1.37-3.79,3.85-5.22a22.11,22.11,0,0,1,19.88,0c2.48,1.43,3.85,3.29,3.85,5.22S238.14,366.63,235.66,368.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,357.62a22.11,22.11,0,0,0-19.88,0c-2.48,1.43-3.85,3.29-3.85,5.22a4.28,4.28,0,0,0,.32,1.61,7.87,7.87,0,0,1,3.53-3.6,22.11,22.11,0,0,1,19.88,0,7.87,7.87,0,0,1,3.53,3.6,4.28,4.28,0,0,0,.32-1.61C239.51,360.91,238.14,359.05,235.66,357.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.72,355.26a20.26,20.26,0,0,0-9.94,2.36c-2.48,1.43-3.85,3.29-3.85,5.22a4.28,4.28,0,0,0,.32,1.61,7.87,7.87,0,0,1,3.53-3.6,20.26,20.26,0,0,1,9.94-2.36h.7c-.9,0-2.81-.47-2.17-1.71s2.37-1.52,3.62-1.44C227.17,355.29,226.45,355.26,225.72,355.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.72,355.26a20.26,20.26,0,0,0-9.94,2.36c-2.48,1.43-3.85,3.29-3.85,5.22a4.28,4.28,0,0,0,.32,1.61,7.87,7.87,0,0,1,3.53-3.6,20.26,20.26,0,0,1,9.94-2.36h.7c-.9,0-2.81-.47-2.17-1.71s2.37-1.52,3.62-1.44C227.17,355.29,226.45,355.26,225.72,355.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51,362.84c0-1.71-1.07-3.35-3-4.7.92,1.07.4,3-1.59,2.3h0c.26.14.52.27.78.42a7.87,7.87,0,0,1,3.53,3.6A4.28,4.28,0,0,0,239.51,362.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51,362.84c0-1.71-1.07-3.35-3-4.7.92,1.07.4,3-1.59,2.3h0c.26.14.52.27.78.42a7.87,7.87,0,0,1,3.53,3.6A4.28,4.28,0,0,0,239.51,362.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,360.85a22.11,22.11,0,0,0-19.88,0,7.87,7.87,0,0,0-3.53,3.6,7.89,7.89,0,0,0,3.53,3.61,22.11,22.11,0,0,0,19.88,0,7.84,7.84,0,0,0,3.53-3.61A7.87,7.87,0,0,0,235.66,360.85Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,360.85a22.11,22.11,0,0,0-19.88,0,7.87,7.87,0,0,0-3.53,3.6,7.89,7.89,0,0,0,3.53,3.61,22.11,22.11,0,0,0,19.88,0,7.84,7.84,0,0,0,3.53-3.61A7.87,7.87,0,0,0,235.66,360.85Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.78,360.85a7.87,7.87,0,0,0-3.53,3.6,7.89,7.89,0,0,0,3.53,3.61,18.69,18.69,0,0,0,7,2.19,12.67,12.67,0,0,0-2.71-1.45c-.31-.07-.6-.16-.89-.24a2.28,2.28,0,0,1-1.28-.72,1.27,1.27,0,0,1-.25-1.23,1.55,1.55,0,0,1,.55-.64c.81-.6,1.84-.82,2.69-1.37a1.13,1.13,0,0,0,.51-.57,1,1,0,0,0-.2-.79c-.17-.23-.39-.42-.56-.65a1,1,0,0,1-.24-.79.86.86,0,0,1,.28-.45,4,4,0,0,1,1.82-.69,1.31,1.31,0,0,0,.87-.63c.19-.32,0-.72.17-1a1.24,1.24,0,0,1,.44-.44A19.25,19.25,0,0,0,215.78,360.85Zm-.15,4.32a.28.28,0,0,1-.22,0c-.06,0-.06-.1,0-.13a.22.22,0,0,1,.22,0C215.69,365.07,215.69,365.13,215.63,365.17Zm1.38,2a.74.74,0,0,1-.68,0c-.19-.11-.19-.29,0-.39a.74.74,0,0,1,.68,0C217.2,366.87,217.2,367.05,217,367.16Zm.3-.89a.22.22,0,0,1-.22,0c-.06,0-.06-.09,0-.13a.28.28,0,0,1,.22,0C217.37,366.18,217.37,366.24,217.31,366.27Zm.14-1.45a1.21,1.21,0,0,1-1.08,0,.33.33,0,0,1,0-.62,1.21,1.21,0,0,1,1.08,0A.33.33,0,0,1,217.45,364.82Zm2.28-3.53a.43.43,0,0,1,.35,0c.09.06.09.15,0,.2a.36.36,0,0,1-.35,0C219.63,361.44,219.63,361.35,219.73,361.29Zm-1.58,1.25a.33.33,0,0,1,0-.62,1.15,1.15,0,0,1,1.08,0,.33.33,0,0,1,0,.62A1.21,1.21,0,0,1,218.15,362.54Zm.71,2.35a.36.36,0,0,1-.35,0c-.09-.05-.09-.14,0-.2a.36.36,0,0,1,.35,0C219,364.75,219,364.84,218.86,364.89Zm1.56-1.54c.34.2.34.52,0,.71a1.34,1.34,0,0,1-1.23,0c-.34-.19-.34-.51,0-.71A1.34,1.34,0,0,1,220.42,363.35Zm1.13-2.92a.22.22,0,0,1-.22,0c-.06,0-.06-.09,0-.13a.28.28,0,0,1,.22,0C221.61,360.34,221.61,360.4,221.55,360.43Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,360.85a15.08,15.08,0,0,0-1.94-.93,3.08,3.08,0,0,0-.54.16,1.05,1.05,0,0,0-.49.36c-.26.41.06.95.41,1.29a9.1,9.1,0,0,0,1.76,1.32,3.38,3.38,0,0,1,.93.71,1.07,1.07,0,0,1,.2,1.09,2.1,2.1,0,0,1-.58.61.85.85,0,0,0-.36.74,1.23,1.23,0,0,0,.36.54.64.64,0,0,1,.18.6.68.68,0,0,1-.56.3,17.61,17.61,0,0,0-2.41.28,1.47,1.47,0,0,0-.78.46c-.17.22-.24.5-.42.7-.4.47-1.12.37-1.73.4a5.8,5.8,0,0,0-2.24.73l-.34.17a19.44,19.44,0,0,0,8.55-2.32,7.84,7.84,0,0,0,3.53-3.61A7.87,7.87,0,0,0,235.66,360.85Zm-1.12.46a1.21,1.21,0,0,1-1.08,0c-.3-.18-.3-.45,0-.63a1.21,1.21,0,0,1,1.08,0C234.84,360.86,234.84,361.13,234.54,361.31Zm.9.88a.68.68,0,0,1-.59,0c-.16-.1-.16-.25,0-.34a.68.68,0,0,1,.59,0C235.6,361.94,235.6,362.09,235.44,362.19Zm-2.21,6.58a.72.72,0,0,1-.67,0,.2.2,0,0,1,0-.38.72.72,0,0,1,.67,0A.2.2,0,0,1,233.23,368.77Zm.8-.35a.42.42,0,0,1-.38,0c-.11-.06-.11-.16,0-.22a.42.42,0,0,1,.38,0C234.14,368.26,234.14,368.36,234,368.42Zm2.78-3.67a.36.36,0,0,1,.32,0c.09.05.09.13,0,.18a.36.36,0,0,1-.32,0A.1.1,0,0,1,236.81,364.75Zm.46,1.77a1.51,1.51,0,0,1-1.4,0c-.39-.22-.39-.58,0-.81a1.57,1.57,0,0,1,1.4,0C237.66,365.94,237.66,366.3,237.27,366.52Zm.5-2.6a.81.81,0,0,1-.77,0,.23.23,0,0,1,0-.44.81.81,0,0,1,.77,0C238,363.6,238,363.8,237.77,363.92Zm.81.23a.34.34,0,0,1-.31,0c-.09,0-.09-.13,0-.18a.34.34,0,0,1,.31,0C238.67,364,238.67,364.1,238.58,364.15Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,358.56a19.19,19.19,0,0,0-8,2.29,7.87,7.87,0,0,0-3.53,3.6,7.89,7.89,0,0,0,3.53,3.61,14.94,14.94,0,0,0,2.13,1c-1.46-.84-2.93-2.1-2.93-3.78C215,362,219,359.09,223.78,358.56Z",
    style: {
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tea-spoon--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-256",
    d: "M227.49,388.76s0,0,0,0h0l0,0h0l0,0v0l-.06,0h0l-18.19-10.06a2.49,2.49,0,0,0,.47-1.31.49.49,0,0,0,0-.12h0c0-.59-.45-1.23-1.41-1.88-2-1.38-6.58-2.58-8.54-1.45a1.37,1.37,0,0,0-.72,1.61h0a5.42,5.42,0,0,0,1.51,2.55h0l.19.19,0,0,.23.22a7,7,0,0,0,1.75,1.23,5.89,5.89,0,0,0,.58.24,5.5,5.5,0,0,0,.95.25,7.58,7.58,0,0,0,1.49.13,4.5,4.5,0,0,0,2.37-.66L225.4,390c.54.32,2.09-.48,2.09-.94v-.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tea-spoon--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.71,379.53c2.16,0,3.94-1.5,3.94-3.13L199,374.68a5.86,5.86,0,0,0,2,3A6.44,6.44,0,0,0,205.71,379.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.71,379.53c2.16,0,3.94-1.5,3.94-3.13L199,374.68a5.86,5.86,0,0,0,2,3A6.44,6.44,0,0,0,205.71,379.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.11,376.65c0,1.16-1.37,2.61-3.53,2.6a7.62,7.62,0,0,1-5.46-2.43,8,8,0,0,0,.82.85,6.44,6.44,0,0,0,4.77,1.86c2.16,0,3.94-1.5,3.94-3.13l-.55-.08C209.1,376.43,209.11,376.55,209.11,376.65Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.24,374.52c-2-1.37-6.58-2.58-8.54-1.45s.14,3.78,2.52,4.93a6.49,6.49,0,0,0,6.15.08C210,377.15,210.21,375.88,208.24,374.52Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,372.74a12.91,12.91,0,0,1,6.35,1.87c.92.64,1.38,1.27,1.36,1.87s-.45,1-1.22,1.5a5.6,5.6,0,0,1-2.79.72,7.45,7.45,0,0,1-3.26-.8c-1.77-.86-3.18-2.42-3.22-3.55a1.25,1.25,0,0,1,.71-1.18,4.14,4.14,0,0,1,2.07-.43m0-.12a4.39,4.39,0,0,0-2.13.45c-1.95,1.13.14,3.78,2.52,4.93a7.62,7.62,0,0,0,3.31.81,5.63,5.63,0,0,0,2.84-.73c1.61-.93,1.84-2.2-.13-3.56a13,13,0,0,0-6.41-1.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,374.81c-2-1.3-6-2.52-7.41-1.57s.89,3.4,3.11,4.51,4,1,5.14.25S209,376.09,207.12,374.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.93,374.34c-1.37-.92-4.26-1.79-5.25-1.12s.63,2.41,2.21,3.2,2.83.74,3.64.18S206.3,375.24,204.93,374.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.36,387.9l-18.44-10.19a5.8,5.8,0,0,1-1.18.68v.27l17.66,10.65c.54.31,2.09-.49,2.09-.95v-.27A.21.21,0,0,0,227.36,387.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.36,387.9l-18.44-10.19a6,6,0,0,1-1.18.68v.27l17.66,10.65c.54.31,2.09-.49,2.09-.95v-.27A.21.21,0,0,0,227.36,387.9Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.4,389c.63.36,2.6-.77,2-1.14l-18.44-10.19a5.91,5.91,0,0,1-1.18.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,378l16.55,9.1c1.25.69,2,1,1.22,1.47s-1.16.3-1.16.3a2,2,0,0,0,.87-.3c.48-.31.07-.71-.86-1.15S209,378,209,378Z",
    style: {
      fill: "#fafafa"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327,154.48l-5.49-3.17a.51.51,0,0,1-.26-.22l-1-1.78,2.74-1.59h.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.27,154.07a.07.07,0,0,1-.06,0l-4-7-7.73,4.48a5.44,5.44,0,0,1-4.81,0l-.57-.35a5.41,5.41,0,0,1-2.41-4.17V122a5.4,5.4,0,0,1,2.4-4.16L357,90.65a5.36,5.36,0,0,1,4.81,0l.57.34a5.42,5.42,0,0,1,2.41,4.17v25c0,1.6,0,2.76-2.15,4l-31.19,18.08L327.33,154Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.37,90.58a4.41,4.41,0,0,1,2.13.49l.6.36a4.91,4.91,0,0,1,2.15,3.73v25c0,1.59,0,2.47-1.91,3.55l-31,18-.32.19-.12.35L327.17,153l-3.32-5.75-.5-.87-.87.51-7.29,4.22a4.9,4.9,0,0,1-4.29,0l-.6-.36a4.92,4.92,0,0,1-2.15-3.73V122a5,5,0,0,1,2.15-3.73l46.91-27.15a4.45,4.45,0,0,1,2.16-.5m0-1a5.4,5.4,0,0,0-2.66.64L309.8,117.37a5.86,5.86,0,0,0-2.65,4.59v25a5.88,5.88,0,0,0,2.65,4.6l.58.35a5.44,5.44,0,0,0,2.65.63,5.5,5.5,0,0,0,2.66-.63l7.29-4.23h0l3.79,6.58a.56.56,0,0,0,.49.28.56.56,0,0,0,.54-.38l4-11.6,31-18c2.38-1.36,2.4-2.73,2.4-4.42v-25a5.86,5.86,0,0,0-2.65-4.59l-.58-.35a5.33,5.33,0,0,0-2.65-.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.16,94.41c-.31-1.13-1.33-1.49-2.56-.78l-46.91,27.15a5.29,5.29,0,0,0-1.87,2l-5.89-3.42a5.5,5.5,0,0,1,1.87-2l46.91-27.15a5.91,5.91,0,0,1,5.31,0l.58.35A5.86,5.86,0,0,1,365.16,94.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.15,147a5.88,5.88,0,0,0,2.65,4.6l.58.35a5.93,5.93,0,0,0,4.85.22c-1.24.47-2.2-.24-2.2-1.75v-25a5.43,5.43,0,0,1,.78-2.62l-5.88-3.41a5.43,5.43,0,0,0-.78,2.61Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.76,132.4a7.33,7.33,0,0,1,.25-1.89,9,9,0,0,1,.72-1.82,8.31,8.31,0,0,1,1.06-1.57,5.24,5.24,0,0,1,1.3-1.09,2.65,2.65,0,0,1,1.31-.41,1.64,1.64,0,0,1,1.06.34,2.24,2.24,0,0,1,.71,1,4.41,4.41,0,0,1,.26,1.59,7.35,7.35,0,0,1-.26,1.89,9.16,9.16,0,0,1-.71,1.82,8.31,8.31,0,0,1-1.06,1.57,5.28,5.28,0,0,1-1.31,1.09,2.62,2.62,0,0,1-1.3.41,1.64,1.64,0,0,1-1.06-.34,2.25,2.25,0,0,1-.72-1A4.42,4.42,0,0,1,321.76,132.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.8,124.87a7.2,7.2,0,0,1,.25-1.88,9,9,0,0,1,.72-1.83,7.51,7.51,0,0,1,1.06-1.56,5.08,5.08,0,0,1,1.3-1.1,2.76,2.76,0,0,1,1.31-.41,1.72,1.72,0,0,1,1.06.34,2.24,2.24,0,0,1,.71,1,4.41,4.41,0,0,1,.26,1.59,7.35,7.35,0,0,1-.26,1.89,9,9,0,0,1-.71,1.83,8.73,8.73,0,0,1-1.06,1.56,5.07,5.07,0,0,1-1.31,1.09,2.62,2.62,0,0,1-1.3.41,1.62,1.62,0,0,1-1.06-.33,2.29,2.29,0,0,1-.72-1A4.42,4.42,0,0,1,334.8,124.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.83,117.34a7.34,7.34,0,0,1,.26-1.88,9,9,0,0,1,.71-1.83,8.38,8.38,0,0,1,1.06-1.56,5.33,5.33,0,0,1,1.31-1.1,2.72,2.72,0,0,1,1.3-.41,1.68,1.68,0,0,1,1.06.34,2.18,2.18,0,0,1,.72,1,4.46,4.46,0,0,1,.25,1.59,7.33,7.33,0,0,1-.25,1.89,8.5,8.5,0,0,1-.72,1.83,7.51,7.51,0,0,1-1.06,1.56,5.29,5.29,0,0,1-1.3,1.1,2.76,2.76,0,0,1-1.31.41,1.72,1.72,0,0,1-1.06-.34,2.24,2.24,0,0,1-.71-1A4.43,4.43,0,0,1,347.83,117.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.06,451.3l0-44.74c0-.84.58-1.86,2.29-2.84l40-23.08c-.26.15.91.16,1.64.58l3.75,2.21a2.94,2.94,0,0,1,1.31,2.29l0,44.73a2.92,2.92,0,0,1-1.31,2.28l-40,23.07a2.85,2.85,0,0,1-2.62,0l-3.75-2.2A3,3,0,0,1,77.06,451.3Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.06,385.72a3,3,0,0,0-1.31-2.3l-3.76-2.2c-.71-.42-1.89-.43-1.63-.58l-40,23.08c-1.36.78-1.69,1.16-1.93,1.6L83.85,409a2.7,2.7,0,0,1,.93-1l39-22.51C125.41,384.57,126.06,384.82,126.06,385.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.53,455.91c-.63.24-1.1-.11-1.1-.87l0-44.73a2.77,2.77,0,0,1,.38-1.3l-6.4-3.7a2.57,2.57,0,0,0-.35,1.25l0,44.74a2.93,2.93,0,0,0,1.31,2.29l3.75,2.2A2.9,2.9,0,0,0,84.53,455.91Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.06,383.07c-.83-.47-5.62-3.31-5.82-3.43a1.23,1.23,0,0,0-1.76.71L92,396.45l6.41,3.73,5-16.39A1.23,1.23,0,0,1,105.06,383.07Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.06,383.07c-.83-.47-5.62-3.31-5.82-3.43a1.23,1.23,0,0,0-1.76.71L92,396.45l6.41,3.73,5-16.39A1.23,1.23,0,0,1,105.06,383.07Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.43,455l0-44.73A2.89,2.89,0,0,1,84.78,408l13.61-7.86,5-16.38a1.18,1.18,0,0,1,2.13-.35l4.78,9.88h0L124.74,385c.73-.42,1.32-.08,1.32.76l0,44.73a2.92,2.92,0,0,1-1.31,2.28l-40,23.07C84,456.22,83.43,455.88,83.43,455Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.83,440.44a7,7,0,0,1-3.58-.94c-3-1.74-4.76-5.75-4.76-11,0-9.81,6-21.25,13.37-25.51,3.3-1.9,6.5-2.15,9-.69,3,1.74,4.76,5.75,4.76,11,0,9.81-6,21.25-13.37,25.51A11,11,0,0,1,99.83,440.44Zm10.47-38.25a10.19,10.19,0,0,0-5,1.52c-7.14,4.12-13,15.24-13,24.79,0,4.94,1.59,8.69,4.35,10.29,2.25,1.3,5.17,1,8.2-.7,7.14-4.12,13-15.24,13-24.79,0-4.95-1.58-8.7-4.34-10.29A6.27,6.27,0,0,0,110.3,402.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,414.46l-5.81,3.36v-7.75c0-.79-.48-1.15-1.07-.81l-1.09.62a2.59,2.59,0,0,0-1.07,2.05v7.75L97.64,423a2.55,2.55,0,0,0-1.07,2v1.45c0,.78.48,1.15,1.07.81l5.81-3.36v7.75c0,.79.48,1.15,1.07.81l1.09-.63a2.55,2.55,0,0,0,1.07-2v-7.75l5.81-3.36a2.57,2.57,0,0,0,1.07-2v-1.45C113.56,414.48,113.08,414.12,112.49,414.46Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewentriesAmico);
export default __webpack_public_path__ + "static/media/New entries-amico.2c0c470ef86b4f96a22634c20692f3fb.svg";
export { ForwardRef as ReactComponent };